var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.47,367.27A35.52,35.52,0,0,0,346.28,362c-2.49-.25-5.2-.18-7.19,1.32a1.48,1.48,0,0,0-.74,1.32,1.57,1.57,0,0,0,.7.89c6.19,4.72,15.54,5.32,22.42,1.7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.08,366.84a74,74,0,0,1-9.81-8.63,24.89,24.89,0,0,1-6.15-11.38,4.58,4.58,0,0,1,.48-3.81c7.83,6.11,14,14,15.48,23.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.39,367.21a35.28,35.28,0,0,1,.19-12.88,17.42,17.42,0,0,1,6.86-10.64c1.35,3.16.77,6.8-.18,10.11a49,49,0,0,1-6.81,14.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.06,381c-4.65.56-8.71,3-12.18,6.16a23.09,23.09,0,0,0-7,12c4.57-.28,8.45-3.5,11.26-7.11s4.75-7.58,7.84-11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.73,383.15a30.06,30.06,0,0,1,3.47-28.43c2.65,9.44,1.68,20.09-3.47,28.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.86,395.22a21.75,21.75,0,0,0-20.78,12,1.61,1.61,0,0,0-.14,1.63,1.56,1.56,0,0,0,1.38.41c4.09-.27,7.72-2.73,10.72-5.54s5.61-6,8.92-8.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.54,394.56a38.69,38.69,0,0,1-.39-21.62c.77-2.78,2-5.71,4.62-7a.88.88,0,0,1,.7-.12.93.93,0,0,1,.45.52,13,13,0,0,1,1.09,6.2,40.57,40.57,0,0,1-1,6.28c-.81,3.84-1.25,8-3.35,11.27a23.72,23.72,0,0,0-1.34,2.48c-.4.84-.4,1.14-.77,1.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.37,398.56c-2-7.56.12-16.72,4.88-22.92.35-.46.82-.95,1.39-.89.88.08,1.11,1.25,1.07,2.13a41.53,41.53,0,0,1-7.34,21.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78,400.21c9.19,2.39,19.73.07,27.36-5.56a22.12,22.12,0,0,0-14.81-1.82c-4.94,1.13-9.47,3.35-12.55,7.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,395.18c5.15-8.39,15-13.86,24.84-14.36-1.14,4-4.42,7.1-8.13,9s-7.84,2.7-11.92,3.49c-1.58.31-3.76.64-4.79,1.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.88,370.76c1.39-4.78,2.79-9.59,3.17-14.55s-.32-10.13-2.89-14.38c-4.81,9.3-5.3,20.16-.43,29.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.05,362.58c5.62-10.21,17.09-18.37,28.69-19.51-4.48,11.14-16.68,19.75-28.69,19.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.52,364.58c8.38,1.28,15.52,6.63,23.35,9.87a10.34,10.34,0,0,0,5.28,1,4.13,4.13,0,0,0,2.59-7.31,11.48,11.48,0,0,0-3.84-2.32c-8.53-3.55-17.68-3.64-26.66-1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67,370.46c1.9.54,2.54,1.52,4.05,2.8a43.73,43.73,0,0,0,17.7,9.1c.68.17,1.57.23,1.9-.38s-.07-1.18-.45-1.65a24.38,24.38,0,0,0-10.7-7.26c-4.08-1.52-7.62-3.36-12.5-3",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,335a33.48,33.48,0,0,0,25.69,8.74,1.78,1.78,0,0,0,1.17-.42c.65-.7-.13-1.79-.88-2.38-7.56-5.89-16.71-8.33-26-5.94",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.69,332.58a35.8,35.8,0,0,1,32.05-5.29A25.42,25.42,0,0,1,433.47,334a48.22,48.22,0,0,1-16.78-1.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,316.27c-.75-7.54-.26-13.49-.79-21.06,0-.61-.17-1.34-.74-1.55-.78-.31-1.44.66-1.7,1.46a24.15,24.15,0,0,0,3.22,21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.56,317.11A44.28,44.28,0,0,0,426.05,305c2.47-3.38,4.55-7.42,4-11.56a11.94,11.94,0,0,0-9,4.47,25.14,25.14,0,0,0-4.59,9.24c-1,3.32-1.7,6.73-2.88,10",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.83,313.7a100.69,100.69,0,0,0,30.74-18.13c-3.67-1.48-7.88-.59-11.55.89-8.38,3.39-15.23,9.1-19.35,17.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,321.23c5.68.62,11.44,1,17.07.08S444.84,318.2,450,316a1.91,1.91,0,0,0,1.09-.82,1.27,1.27,0,0,0-.39-1.37,3.33,3.33,0,0,0-1.36-.63c-5.62-1.57-11.69-.84-17.22,1a80,80,0,0,0-15.12,7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,335.22c-3.87-7.82-3.62-16.94-.28-25,2.35,3.59,2.64,8.16,2.21,12.42s-1.73,8.67-1.81,13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,327.42a34.81,34.81,0,0,0-25.89,11c4.82.76,9.79-.49,14.18-2.63a72.75,72.75,0,0,0,12.15-8.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.76,323.94c-4.73-.38-9.28-1-13.83.42s-8.68,4.56-10.53,8.94a25,25,0,0,0,13-2.45,75.41,75.41,0,0,0,11.4-6.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,324.1c-4.25-2.79-8.62-5.63-13.57-6.78s-10.7-.3-14.15,3.43c4,2.35,8.87,2.63,13.52,2.63s10.35-.06,14.73,1.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.17,324.32c-7.27-7.14-10-20-7.1-29.73a45.24,45.24,0,0,1,7.1,29.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,304.09c1.37-3.19,2.34-6.53,3.57-9.78a28.13,28.13,0,0,1,5.08-9,13.36,13.36,0,0,1,9-4.67,36.26,36.26,0,0,1-17.48,23.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.55,308.31c-2.27-3.13-4.89-7.37-8-9.7s-7.08-3.74-10.84-2.84a25.27,25.27,0,0,0,18.81,12.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.27,304.35a54.32,54.32,0,0,1-3.58-11.61,18.12,18.12,0,0,1,1.82-11.82c4,7.55,5.27,15.65,2,23.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.21,280.92c2.26-7.48,9.11-13,16.5-15.51a6,6,0,0,1,2.89-.43,2.51,2.51,0,0,1,2.14,1.78C416,268,415,269.17,414,270a56.13,56.13,0,0,1-19.76,10.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.29,274.81c.29-4.83.59-9.72,2.15-14.29s4.6-8.85,9-10.85c.75,4.87-1.4,9.71-4,13.9s-5.71,8.15-7.27,12.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,278.13c-1.87-5.46-2.06-12.38-5.33-17.13-2.28-3.32-5.93-5.58-7.9-9.1a13.9,13.9,0,0,0,.46,10.33,29.91,29.91,0,0,0,6,8.65c2.42,2.58,4.48,4.52,6.73,7.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.21,438.66c-.15,0-.27-36.37-.28-81.21s.09-81.22.24-81.22.27,36.35.28,81.22S394.35,438.66,394.21,438.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,329.73a7.46,7.46,0,0,1-1.36.51l-3.77,1.27c-3.17,1.08-7.53,2.65-12.26,4.59s-9.1,3.64-11.61,5.82a8.58,8.58,0,0,0-2.34,3.08c-.36.86-.42,1.38-.47,1.37s0-.13,0-.38a5.83,5.83,0,0,1,.26-1.06,8.22,8.22,0,0,1,2.28-3.29,20.27,20.27,0,0,1,5-3.13c2-.94,4.25-1.92,6.62-2.9,4.75-1.94,9.14-3.46,12.35-4.45,1.6-.5,2.91-.87,3.82-1.11A7.2,7.2,0,0,1,426,329.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4,304.14s-.12.16-.38.41l-1.17,1.1-4.36,4L416,322.52c-5.66,5-10.56,9.85-13.95,13.47-1.69,1.81-3,3.31-3.94,4.36q-.64.72-1.05,1.2c-.25.27-.38.41-.4.4a3,3,0,0,1,.31-.46c.22-.3.54-.73,1-1.27.87-1.09,2.16-2.63,3.83-4.48a182.59,182.59,0,0,1,13.87-13.62c5.67-5,10.84-9.54,14.6-12.79l4.47-3.83,1.23-1A2.36,2.36,0,0,1,436.4,304.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.89,327.64c-.15-.07,1-2.8,2.21-6.25s1.75-6.37,1.9-6.34a21.73,21.73,0,0,1-1.4,6.51,43.21,43.21,0,0,1-1.77,4.37A6.93,6.93,0,0,1,409.89,327.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.24,349.65a6.42,6.42,0,0,1-.87-1l-2.24-2.87c-1.87-2.42-4.47-5.77-7.38-9.44s-5.58-6.95-7.52-9.33c-.91-1.13-1.67-2.08-2.28-2.82a8.48,8.48,0,0,1-.79-1.08,5.59,5.59,0,0,1,.95.94c.58.63,1.4,1.56,2.41,2.72,2,2.32,4.73,5.58,7.64,9.25s5.47,7.05,7.27,9.54c.9,1.24,1.62,2.26,2.1,3A6.23,6.23,0,0,1,394.24,349.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.27,340.7a12.85,12.85,0,0,1-2.92-5.46,15.52,15.52,0,0,1-.66-5.51l.23,0c-.1.42-.18.64-.22.64s0-.25,0-.68l.23,0a25.46,25.46,0,0,0,.94,5.36A40,40,0,0,0,387.27,340.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.28,329.39a9.68,9.68,0,0,0-2-1.19,13.79,13.79,0,0,0-5.66-.45,35.92,35.92,0,0,0-5.7.92,18.65,18.65,0,0,1-2.34.57,7.62,7.62,0,0,1,2.24-.92,26.14,26.14,0,0,1,5.76-1.09,12.33,12.33,0,0,1,5.84.63A3.7,3.7,0,0,1,378.28,329.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.14,326.65c0,.08-1.18-.48-3.12-1.14a31.52,31.52,0,0,0-15.73-1.2c-2,.36-3.24.74-3.26.65a3,3,0,0,1,.83-.35,17.82,17.82,0,0,1,2.35-.67,27.81,27.81,0,0,1,15.94,1.22,20.74,20.74,0,0,1,2.23,1C375.89,326.45,376.16,326.61,376.14,326.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,315.05a65.09,65.09,0,0,1-2.28-7.91,66.69,66.69,0,0,1-1.77-8A63,63,0,0,1,392.4,307,64,64,0,0,1,394.17,315.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.31,315.05a36.83,36.83,0,0,0-2.52-4.74,21,21,0,0,0-3.71-3.83,3.58,3.58,0,0,1,1.43.74,11.48,11.48,0,0,1,2.71,2.79A10.4,10.4,0,0,1,394.31,315.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.21,419.27c-.06,0-.17-.87-.58-2.41a34,34,0,0,0-2.43-6.3c-2.51-5.13-7.08-11.64-12.89-18.16-2.88-3.29-5.67-6.4-8-9.37a64.22,64.22,0,0,1-5.75-8.29,40.74,40.74,0,0,1-2.91-6.15c-.26-.76-.46-1.35-.57-1.76a2.76,2.76,0,0,1-.14-.63s.31.83.91,2.31a43.62,43.62,0,0,0,3,6,69.44,69.44,0,0,0,5.8,8.18c2.38,2.94,5.18,6,8.07,9.32,5.82,6.54,10.38,13.13,12.83,18.35a31.29,31.29,0,0,1,2.29,6.41,16.93,16.93,0,0,1,.32,1.82A3.42,3.42,0,0,1,394.21,419.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.92,386.84a11.71,11.71,0,0,1-1.5.84,33.88,33.88,0,0,0-3.91,2.58,45.15,45.15,0,0,0-5.12,4.68c-1.8,1.9-3.66,4.11-5.55,6.47-3.78,4.75-7.32,8.95-9.44,12.3-1.07,1.66-1.85,3.07-2.37,4.05a13.63,13.63,0,0,1-.82,1.51,1.3,1.3,0,0,1,.14-.42c.11-.27.26-.68.5-1.18a38.8,38.8,0,0,1,2.24-4.16c2.06-3.43,5.57-7.69,9.34-12.43,1.9-2.36,3.77-4.58,5.61-6.47a40.66,40.66,0,0,1,5.25-4.64,27.67,27.67,0,0,1,4-2.47c.5-.25.91-.4,1.18-.52S422.91,386.82,422.92,386.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.48,397.36a20.08,20.08,0,0,1-3.18.46,42.19,42.19,0,0,0-7.54,1.49,23,23,0,0,0-6.76,3.54c-1.55,1.21-2.29,2.2-2.36,2.14a3,3,0,0,1,.47-.73,12.06,12.06,0,0,1,1.66-1.69,20.44,20.44,0,0,1,6.83-3.76,33.81,33.81,0,0,1,7.67-1.36A17.52,17.52,0,0,1,423.48,397.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.57,403.84c-.17-.1,1.27-2.29,2.38-5.23s1.29-5.58,1.47-5.55a4.88,4.88,0,0,1-.05,1.71,18.25,18.25,0,0,1-.93,4,19.39,19.39,0,0,1-1.84,3.69A5.19,5.19,0,0,1,404.57,403.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.22,358.59a2.13,2.13,0,0,1-.51.27l-1.49.68c-.66.28-1.45.64-2.35,1.11s-1.94.94-3,1.6l-1.73,1c-.6.35-1.2.76-1.83,1.16-1.28.77-2.56,1.73-3.93,2.7a74.3,74.3,0,0,0-8.2,7.22,73.41,73.41,0,0,0-6.93,8.44c-.93,1.4-1.84,2.72-2.57,4-.38.65-.77,1.26-1.09,1.87s-.63,1.2-.93,1.77c-.62,1.11-1.06,2.18-1.49,3.09s-.77,1.72-1,2.38-.46,1.12-.63,1.52a2.87,2.87,0,0,1-.25.52,1.93,1.93,0,0,1,.15-.56l.54-1.55c.23-.68.53-1.5.95-2.43s.83-2,1.43-3.14l.9-1.79c.32-.63.7-1.24,1.07-1.9.72-1.32,1.62-2.65,2.55-4.07a64.91,64.91,0,0,1,15.24-15.78c1.39-1,2.69-1.92,4-2.68.65-.39,1.25-.8,1.86-1.14l1.77-1c1.11-.64,2.17-1.1,3.09-1.54s1.72-.78,2.39-1l1.53-.59A2.23,2.23,0,0,1,432.22,358.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,373.82a3.57,3.57,0,0,1,1.24-1.86,7.94,7.94,0,0,1,5-1.94,13.93,13.93,0,0,1,5.3,1,7.42,7.42,0,0,1,2,1,11.06,11.06,0,0,1-2.12-.62,15.82,15.82,0,0,0-5.16-.86,8.19,8.19,0,0,0-4.81,1.69A14.29,14.29,0,0,0,409.5,373.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.1,377.32a19.13,19.13,0,0,0,1.43-4.65,19.38,19.38,0,0,0-.32-4.86,3.13,3.13,0,0,1,.59,1.36,9.6,9.6,0,0,1-.82,7C406.54,376.94,406.15,377.36,406.1,377.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.09,424.48c.78,13.9,5,28,11.41,42.32h28c6.15-14.14,10.05-28.25,10.74-42.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.71,447c0,.15-9.22.27-20.6.27s-20.6-.12-20.6-.27,9.22-.26,20.6-.26S414.71,446.83,414.71,447Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.08,452c0,.14-8.64.26-19.31.26s-19.31-.12-19.31-.26,8.65-.27,19.31-.27S414.08,451.86,414.08,452Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,433.61a77.18,77.18,0,0,1,0,12.9,80.13,80.13,0,0,1,0-12.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,433.61A82.77,82.77,0,0,1,396,447a85.94,85.94,0,0,1,0-13.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,433.5a86.14,86.14,0,0,1,0,13.63,89.45,89.45,0,0,1,0-13.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,433.61c0,.14-10.82.26-24.16.26s-24.16-.12-24.16-.26,10.82-.26,24.16-.26S418.36,433.46,418.36,433.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.88,229.35a16.52,16.52,0,0,1,4-1.75l.83-4,6.74-.12,1,4a16.73,16.73,0,0,1,4.1,1.61l3.41-2.23,4.85,4.68L223.7,235a16.52,16.52,0,0,1,1.75,4l4,.83.12,6.75-4,1a16.82,16.82,0,0,1-1.61,4.09l2.23,3.41-4.68,4.85-3.49-2.11a16.52,16.52,0,0,1-4,1.75l-.83,4-6.75.12-1-4a16.42,16.42,0,0,1-4.09-1.61L198,260.35l-4.85-4.69,2.11-3.48a16.76,16.76,0,0,1-1.75-4l-4-.83-.12-6.74,4-1a16.34,16.34,0,0,1,1.61-4.1l-2.24-3.41,4.69-4.85,3.49,2.11Zm3.59,9a7.23,7.23,0,1,0,10.23-.18A7.23,7.23,0,0,0,204.47,238.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,238.34a5.55,5.55,0,0,1,1.35-1.18,7.17,7.17,0,0,1,4.72-1.12,7.33,7.33,0,0,1,5.8,4.06,7.07,7.07,0,0,1,.66,2,6.87,6.87,0,0,1,0,2.22,7.37,7.37,0,0,1-6.11,6.33,6.91,6.91,0,0,1-2.22,0,7,7,0,0,1-2.06-.59,7.43,7.43,0,0,1-3-2.49,7.24,7.24,0,0,1-1.25-3.17,7.17,7.17,0,0,1,1-4.75,5.47,5.47,0,0,1,1.13-1.39,15.37,15.37,0,0,0-1,1.47,7.11,7.11,0,0,0-.8,4.63,7,7,0,0,0,1.24,3,7,7,0,0,0,2.89,2.34,6.64,6.64,0,0,0,1.95.55,6.81,6.81,0,0,0,2.11-.05,7,7,0,0,0,5.77-6,6.78,6.78,0,0,0,0-2.11,6.59,6.59,0,0,0-.61-1.93,7.1,7.1,0,0,0-5.49-3.94,7.25,7.25,0,0,0-4.61,1C204.93,237.89,204.51,238.38,204.47,238.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.88,229.35a1,1,0,0,1-.23-.11l-.67-.39-2.62-1.55h.08l-4.66,4.88V232l2.25,3.4,0,.06,0,.06a16.44,16.44,0,0,0-1.59,4.07l0,.08-.08,0-4,1,.12-.15q.06,3.19.13,6.75l-.13-.16,4,.82.11,0,0,.1a16.3,16.3,0,0,0,1.74,4l.06.1-.06.09-2.1,3.49,0-.23,4.86,4.68-.24,0,3.4-2.23.1-.07.11.06a16.68,16.68,0,0,0,4,1.59l.12,0,0,.11c.3,1.24.64,2.6,1,4l-.2-.15,6.74-.12-.19.16c.26-1.26.54-2.62.83-4l0-.12.12,0a15.77,15.77,0,0,0,4-1.73h0l.1-.06.11.06c1.17.71,2.33,1.42,3.49,2.11l-.26,0,4.69-4.85,0,.25-2.23-3.41-.07-.1.06-.11a16,16,0,0,0,1.59-4l0-.12.12,0,4-1-.15.2c0-2.3-.07-4.55-.11-6.74l.15.18-4-.84-.11,0,0-.11a16,16,0,0,0-1.73-4l0-.09,0-.1,2.12-3.48,0,.22-4.84-4.7.19,0-3.41,2.23-.08,0-.08,0a16.59,16.59,0,0,0-4.05-1.61l-.08,0,0-.08-1-4,.13.09-6.75.09.09-.07c-.34,1.59-.62,2.9-.86,4v0l0,0a17,17,0,0,0-3.09,1.18l-.72.38a1.25,1.25,0,0,1-.24.12l.22-.15c.15-.09.39-.24.71-.41a16.36,16.36,0,0,1,3.08-1.25l0,.05c.22-1.09.49-2.4.81-4v-.07h.08l6.74-.15h.1l0,.09,1,4-.1-.1a16.62,16.62,0,0,1,4.13,1.61h-.15l3.4-2.25.1-.07.1.09,4.86,4.68.1.09-.07.12c-.69,1.13-1.39,2.29-2.11,3.49v-.19a17.16,17.16,0,0,1,1.78,4.08l-.14-.13,4,.82.15,0v.15q.06,3.28.13,6.74v.16l-.15,0-4,1,.14-.14a17,17,0,0,1-1.62,4.14v-.21L226.4,255l.08.13-.11.12-4.68,4.86-.12.11-.14-.08L218,258h.21a16.72,16.72,0,0,1-4.08,1.77l.14-.16c-.28,1.37-.57,2.73-.83,4l0,.16h-.17l-6.74.11h-.17l0-.16c-.34-1.37-.67-2.72-1-4l.14.15a16.49,16.49,0,0,1-4.13-1.64h.2l-3.41,2.23-.13.08-.11-.11c-1.69-1.62-3.33-3.21-4.85-4.69l-.11-.1.08-.13,2.12-3.48v.19a16.77,16.77,0,0,1-1.77-4.08l.13.12-4-.84-.12,0v-.13c0-2.36-.07-4.62-.1-6.74v-.12l.11,0,4-1-.1.1a16.87,16.87,0,0,1,1.63-4.12v.13l-2.22-3.42-.05-.07.06-.06,4.71-4.82,0,0,0,0,2.57,1.6.66.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.43,43.83a16.64,16.64,0,0,1,4.09-1.78l.84-4,6.84-.12,1,4a16.74,16.74,0,0,1,4.15,1.63l3.46-2.26L233.71,46l-2.14,3.53a17,17,0,0,1,1.78,4.09l4,.84.12,6.84-4,1a17.23,17.23,0,0,1-1.63,4.14l2.26,3.46-4.75,4.92-3.53-2.14a17.2,17.2,0,0,1-4.09,1.78l-.85,4-6.83.12-1-4A16.9,16.9,0,0,1,208.94,73l-3.45,2.26-4.93-4.75L202.71,67a16.81,16.81,0,0,1-1.78-4.09L196.88,62l-.12-6.84,4-1a16.51,16.51,0,0,1,1.63-4.15l-2.27-3.45,4.75-4.92,3.54,2.14Zm3.64,9.11a7.34,7.34,0,1,0,10.38-.18A7.33,7.33,0,0,0,212.07,52.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.07,52.94a5.73,5.73,0,0,1,1.37-1.2,7.31,7.31,0,0,1,4.79-1.13,7.46,7.46,0,0,1,3.25,1.15,7.55,7.55,0,0,1,2.63,3,7.49,7.49,0,0,1,.71,4.32,7.48,7.48,0,0,1-6.19,6.41,7.55,7.55,0,0,1-4.34-.55,7.54,7.54,0,0,1-3.06-2.53A7.43,7.43,0,0,1,210,59.17a7.33,7.33,0,0,1,1-4.82,5.65,5.65,0,0,1,1.15-1.41,17.25,17.25,0,0,0-1,1.49,7.23,7.23,0,0,0-.81,4.69,7.17,7.17,0,0,0,4.18,5.43,6.53,6.53,0,0,0,2,.55,6.69,6.69,0,0,0,2.14,0A7.13,7.13,0,0,0,224.41,59a7.15,7.15,0,0,0-.65-4.09,7.23,7.23,0,0,0-10.23-3C212.54,52.48,212.11,53,212.07,52.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.43,43.83l-.23-.12-.68-.39-2.66-1.58h.08l-4.72,5v-.13L202.51,50l0,.06,0,.06a16.84,16.84,0,0,0-1.61,4.12l0,.09-.08,0-4,1,.11-.15q.06,3.24.14,6.84l-.13-.16,4,.84.11,0,0,.1a16.48,16.48,0,0,0,1.76,4l.06.1-.06.09c-.66,1.1-1.39,2.31-2.14,3.54l0-.23,4.93,4.74-.24,0,3.45-2.27.1-.07.11.06a16.61,16.61,0,0,0,4.1,1.61l.12,0,0,.12c.31,1.26.64,2.63,1,4l-.21-.16,6.84-.12-.2.16c.27-1.28.55-2.66.84-4l0-.12.12,0a16.16,16.16,0,0,0,4-1.75h0l.11-.07.11.07,3.53,2.14-.26,0c1.6-1.67,3.19-3.31,4.75-4.92l0,.26-2.27-3.46-.07-.11.06-.11a16.45,16.45,0,0,0,1.62-4.09l0-.12.12,0,4-1-.16.19c0-2.33-.07-4.61-.11-6.83l.15.18-4-.85-.11,0,0-.11a16.48,16.48,0,0,0-1.75-4l0-.09,0-.09,2.15-3.53,0,.21-4.91-4.76.2,0-3.46,2.26-.08.05-.08-.05A16.82,16.82,0,0,0,221.15,42l-.08,0,0-.08-1-4,.12.1-6.84.09.09-.08c-.34,1.62-.63,2.94-.86,4v0h0a16.77,16.77,0,0,0-3.13,1.2l-.74.38-.24.13.23-.16c.15-.09.39-.24.72-.41A15.56,15.56,0,0,1,212.5,42l-.05,0c.23-1.11.49-2.44.82-4.06v-.07h.08l6.84-.15h.1l0,.09c.31,1.24.64,2.56,1,4l-.1-.11a17.13,17.13,0,0,1,4.19,1.64h-.16l3.45-2.27.11-.07.09.09,4.93,4.74.1.1-.07.12c-.69,1.15-1.4,2.32-2.14,3.53v-.18a17,17,0,0,1,1.81,4.13l-.15-.13,4.05.83.15,0v.16q.06,3.33.12,6.84v.16l-.16,0-4,1,.15-.15a17.37,17.37,0,0,1-1.65,4.21v-.22l2.26,3.46.1.14-.12.12L229.53,75l-.12.12-.14-.09-3.53-2.14H226a16.68,16.68,0,0,1-4.14,1.8l.15-.16c-.29,1.39-.58,2.77-.84,4l0,.16h-.16l-6.84.12h-.17l0-.16c-.33-1.38-.67-2.75-1-4l.15.15a17.44,17.44,0,0,1-4.2-1.66h.21l-3.46,2.27-.13.08-.11-.11-4.92-4.75-.1-.11.07-.13c.75-1.23,1.49-2.43,2.15-3.53v.19a17.35,17.35,0,0,1-1.79-4.13l.13.12-4-.85-.13,0V62c0-2.4-.08-4.69-.11-6.84v-.12l.12,0,4-1-.1.1A17.21,17.21,0,0,1,202.3,50v.13l-2.26-3.47,0-.07.06-.06,4.78-4.89,0,0,.05,0,2.6,1.62.67.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.29,191.63a13.88,13.88,0,0,1,3.43-1.49l.71-3.4,5.74-.1L200,190a14.07,14.07,0,0,1,3.49,1.37l2.9-1.9,4.13,4-1.8,3a13.91,13.91,0,0,1,1.5,3.43l3.4.71.1,5.75-3.37.82a14.1,14.1,0,0,1-1.38,3.49l1.91,2.9-4,4.14-3-1.8a14.51,14.51,0,0,1-3.44,1.49l-.71,3.4-5.74.1-.83-3.37a14.57,14.57,0,0,1-3.48-1.37l-2.91,1.9-4.13-4,1.8-3a13.58,13.58,0,0,1-1.49-3.44l-3.4-.7-.1-5.75,3.37-.83a14.16,14.16,0,0,1,1.37-3.48l-1.9-2.9,4-4.14,3,1.8Zm3.06,7.65a6.17,6.17,0,1,0,8.71-.15A6.16,6.16,0,0,0,192.35,199.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35,199.28a4.6,4.6,0,0,1,1.15-1,6.22,6.22,0,0,1,6.75,0,6.25,6.25,0,0,1,2.21,2.49,5.85,5.85,0,0,1,.56,1.73,6,6,0,0,1,0,1.9,6.29,6.29,0,0,1-5.21,5.39,6,6,0,0,1-1.89,0,5.9,5.9,0,0,1-1.75-.5,6.26,6.26,0,0,1-3.64-4.82,6.15,6.15,0,0,1,.81-4.05,4.8,4.8,0,0,1,1-1.19s-.37.41-.85,1.26a6.18,6.18,0,0,0-.68,3.94,6,6,0,0,0,3.52,4.56,5.37,5.37,0,0,0,1.66.46,5.46,5.46,0,0,0,1.8,0,6,6,0,0,0,4.91-5.09,5.71,5.71,0,0,0,0-1.8,5.62,5.62,0,0,0-.52-1.64,6.08,6.08,0,0,0-8.6-2.54C192.74,198.9,192.38,199.32,192.35,199.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.29,191.63l-.2-.1-.56-.33-2.24-1.32h.07l-4,4.16v-.11l1.92,2.89,0,.05,0,.06a14.09,14.09,0,0,0-1.35,3.46l0,.07-.06,0-3.37.83.09-.12c0,1.81.08,3.73.12,5.74l-.12-.13,3.41.7.08,0,0,.08a13.94,13.94,0,0,0,1.48,3.4l0,.08,0,.08-1.8,3,0-.2,4.14,4-.21,0,2.9-1.9.09-.06.09,0a14,14,0,0,0,3.44,1.35l.1,0,0,.1.83,3.37-.17-.13,5.74-.11-.17.14c.23-1.07.47-2.23.71-3.4l0-.1.1,0a14,14,0,0,0,3.39-1.47h0l.09-.06.09.06,3,1.8-.22,0,4-4.13,0,.22-1.9-2.91-.06-.08,0-.1a13.7,13.7,0,0,0,1.36-3.44l0-.1.1,0,3.38-.83-.13.17c0-2-.06-3.88-.1-5.75l.13.16-3.39-.71-.1,0,0-.09a13.84,13.84,0,0,0-1.48-3.4l0-.08,0-.08,1.81-3,0,.19-4.12-4h.16l-2.9,1.9-.07,0-.06,0a14.15,14.15,0,0,0-3.46-1.37h-.07V190c-.3-1.23-.56-2.33-.82-3.38l.11.08-5.75.08.08-.07-.73,3.4v0h0a15,15,0,0,0-2.63,1l-.62.33-.2.1.19-.13.6-.35a13.94,13.94,0,0,1,2.63-1.07l0,0c.18-.93.41-2,.68-3.41v-.06h.07l5.74-.13h.09l0,.08c.26,1,.53,2.15.83,3.37l-.08-.08a14.29,14.29,0,0,1,3.52,1.37h-.13l2.9-1.91.09-.06.07.07,4.15,4,.08.09-.06.1-1.79,3v-.16a14.59,14.59,0,0,1,1.51,3.47l-.12-.11,3.4.7.13,0v.13c0,1.87.07,3.78.11,5.74v.14l-.13,0-3.37.83.12-.13a14.38,14.38,0,0,1-1.38,3.53v-.18l1.9,2.91.08.11-.1.1-4,4.14-.09.1-.13-.07-3-1.8H204a14.69,14.69,0,0,1-3.48,1.51l.12-.13c-.24,1.16-.48,2.32-.7,3.4l0,.13h-.14L194,221h-.14l0-.14c-.28-1.16-.57-2.32-.82-3.37l.12.12a14,14,0,0,1-3.52-1.39h.17l-2.91,1.9-.11.07-.09-.09-4.13-4-.09-.09.07-.1c.62-1,1.24-2.05,1.8-3v.16a13.77,13.77,0,0,1-1.5-3.48l.11.11-3.4-.72-.11,0v-.11c0-2-.06-3.94-.09-5.75v-.1l.1,0,3.37-.82-.08.09a14,14,0,0,1,1.39-3.51v.11L182.25,194l0-.06,0,0,4-4.11,0,0,0,0,2.18,1.36.57.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,188.67a24,24,0,0,1,5.92-2.57l1.22-5.86,9.9-.17,1.43,5.81a24.4,24.4,0,0,1,6,2.36l5-3.28,7.12,6.88-3.1,5.12a24,24,0,0,1,2.57,5.92l5.86,1.22.18,9.9-5.82,1.43a24,24,0,0,1-2.36,6l3.28,5-6.88,7.12-5.11-3.1a24.27,24.27,0,0,1-5.93,2.57l-1.22,5.86-9.9.18-1.42-5.82a24.31,24.31,0,0,1-6-2.36l-5,3.28L255,227.29l3.1-5.11a24.27,24.27,0,0,1-2.57-5.93L249.66,215l-.17-9.9,5.81-1.42a24.31,24.31,0,0,1,2.36-6l-3.28-5,6.88-7.13,5.12,3.1Zm5.28,13.19a10.62,10.62,0,1,0,15-.26A10.63,10.63,0,0,0,271.66,201.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.66,201.86a7.88,7.88,0,0,1,2-1.73,10.53,10.53,0,0,1,6.93-1.64,10.77,10.77,0,0,1,4.71,1.67,11,11,0,0,1,3.81,4.29,10.37,10.37,0,0,1,1,3,10.22,10.22,0,0,1,.06,3.27,10.86,10.86,0,0,1-9,9.29,10.26,10.26,0,0,1-3.27.05,10.44,10.44,0,0,1-3-.86,10.78,10.78,0,0,1-4.42-3.66A10.73,10.73,0,0,1,270,203.9a8.08,8.08,0,0,1,1.67-2A25.48,25.48,0,0,0,270.2,204a10.6,10.6,0,0,0-1.18,6.8,10.43,10.43,0,0,0,1.83,4.42,10.31,10.31,0,0,0,4.24,3.44,9.69,9.69,0,0,0,2.86.79,9.45,9.45,0,0,0,3.09-.06,10.31,10.31,0,0,0,8.48-8.78,10.33,10.33,0,0,0-.94-5.93,10.33,10.33,0,0,0-8.06-5.78,10.58,10.58,0,0,0-6.76,1.41C272.33,201.2,271.71,201.92,271.66,201.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,188.67a2.28,2.28,0,0,1-.33-.17l-1-.57-3.86-2.28h.12c-1.75,1.83-4.05,4.25-6.84,7.16l0-.19,3.3,5,.06.09-.05.1a24.43,24.43,0,0,0-2.33,6l0,.12-.12,0-5.81,1.44.16-.21c.07,3.12.13,6.43.2,9.9l-.19-.23,5.86,1.21.15,0,0,.14a24.3,24.3,0,0,0,2.56,5.86l.08.13-.08.14-3.1,5.12,0-.33c2.24,2.15,4.66,4.48,7.13,6.87l-.35,0,5-3.28.15-.1.15.09A24.51,24.51,0,0,0,273.2,233l.17,0,0,.17c.45,1.82.94,3.81,1.43,5.82l-.29-.23,9.9-.18-.29.24c.38-1.85.8-3.85,1.22-5.86l0-.18.18,0a23.69,23.69,0,0,0,5.84-2.54h0l.16-.1.15.1,5.12,3.1-.38,0,6.88-7.12,0,.37q-1.66-2.52-3.28-5l-.1-.16.09-.15a24.32,24.32,0,0,0,2.34-5.94l0-.17.17,0,5.82-1.42-.22.28c-.06-3.38-.11-6.68-.17-9.9l.23.27-5.86-1.22-.16,0-.05-.16a24.2,24.2,0,0,0-2.53-5.86l-.09-.13.09-.14,3.11-5.11,0,.31-7.11-6.89.29,0-5,3.27-.11.07-.11-.07a24.56,24.56,0,0,0-5.95-2.36l-.12,0,0-.11c-.51-2.12-1-4-1.4-5.82l.17.14-9.9.13.13-.11c-.5,2.33-.91,4.25-1.25,5.85l0,.06h-.05a24.83,24.83,0,0,0-4.53,1.75l-1.07.55a2.53,2.53,0,0,1-.35.18l.33-.22c.23-.14.57-.35,1-.6a23.31,23.31,0,0,1,4.52-1.84l-.07.07c.33-1.6.71-3.52,1.19-5.87l0-.1h.11l9.9-.21h.14l0,.14c.44,1.8.92,3.7,1.44,5.81l-.15-.15a25,25,0,0,1,6.07,2.37h-.23l5-3.29.16-.1.13.13,7.14,6.86.14.14-.1.17-3.09,5.12v-.27a25.27,25.27,0,0,1,2.61,6l-.21-.19,5.86,1.21.22.05v.22q.09,4.83.19,9.9v.24l-.22.05-5.82,1.43.22-.21a24.26,24.26,0,0,1-2.39,6.08v-.31l3.28,5,.13.2-.16.18-6.88,7.12-.17.18-.21-.13-5.11-3.1h.31a24.13,24.13,0,0,1-6,2.6l.21-.23c-.42,2-.83,4-1.22,5.86l-.05.24h-.24l-9.9.16h-.24l-.06-.23c-.49-2-1-4-1.42-5.82l.22.22a24.72,24.72,0,0,1-6.08-2.4h.3l-5,3.28-.19.12-.16-.16-7.12-6.88-.15-.15.11-.19,3.11-5.11v.27a24.64,24.64,0,0,1-2.59-6l.19.18-5.86-1.23-.19,0V215c0-3.48-.1-6.79-.15-9.9V205l.17,0,5.81-1.41-.14.15a24.11,24.11,0,0,1,2.4-6v.19l-3.26-5-.06-.1.08-.09,6.92-7.09.06-.05.06,0,3.77,2.34,1,.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,219.56a14.49,14.49,0,1,0-22.23-4.8l-3.11,2.56.4,4.93L87,220.69l-3.9,3.22.41,4.92L79,227.27,75.66,230l.24,3-2.73-.95L70.66,232l-.72,5.78,7.37,2.53,23.14-19.09A14.51,14.51,0,0,0,116.4,219.56Zm-1.05-17.92a4.16,4.16,0,1,1-5.86-.56A4.16,4.16,0,0,1,115.35,201.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.35,201.64a4.16,4.16,0,1,1-5.86-.56A4.16,4.16,0,0,1,115.35,201.64Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,217.89a14.49,14.49,0,1,0-22.24-4.8h0l-3.11,2.56.41,4.93L86.59,219l-3.89,3.21.4,4.93-4.48-1.56-3.35,2.76.25,3-2.74-1L70.84,232l-.56,4.51,6.65,2.11,23.14-19.09A14.51,14.51,0,0,0,116,217.89ZM115,200a4.16,4.16,0,1,1-5.85-.56A4.16,4.16,0,0,1,115,200Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,217.89a14.49,14.49,0,1,0-22.24-4.8h0l-3.11,2.56.41,4.93L86.59,219l-3.89,3.21.4,4.93-4.48-1.56-3.35,2.76.25,3-2.74-1L70.84,232l-.56,4.51,6.65,2.11,23.14-19.09A14.51,14.51,0,0,0,116,217.89ZM115,200a4.16,4.16,0,1,1-5.85-.56A4.16,4.16,0,0,1,115,200Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,200s-.25-.27-.79-.64a4.16,4.16,0,0,0-2.57-.74,4,4,0,1,0,4.07,4.94,4.1,4.1,0,0,0-.23-2.66c-.26-.6-.51-.88-.48-.9s.08.06.19.19a2.92,2.92,0,0,1,.42.65,4.11,4.11,0,0,1,.35,2.78,4.31,4.31,0,0,1-7.51,1.79,4.33,4.33,0,0,1-.38-5,4.27,4.27,0,0,1,3.56-2.08,4.16,4.16,0,0,1,2.67.87,3.52,3.52,0,0,1,.55.54C114.92,199.89,115,200,115,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,217.89l-.22.18-.68.53a14.9,14.9,0,0,1-2.9,1.61,14.56,14.56,0,0,1-12.2-.57h.12L77,238.77l-.07,0-.08,0-6.65-2.1-.13,0,0-.14c.17-1.41.35-2.95.54-4.51v-.07l.06,0,1.94-1.61.08-.06.09,0,2.74.95-.24.18c-.07-.94-.16-2-.25-3v-.09l.07-.06,3.34-2.76.08-.07.09,0L83.16,227l-.24.19c-.12-1.57-.26-3.24-.4-4.93v-.1l.07-.06,1-.85,2.86-2.36.07-.06.1,0,4.49,1.56-.24.19c-.14-1.66-.27-3.31-.4-4.93v-.09l.07-.06L93.67,213l0,.22a14.76,14.76,0,0,1-1.47-6.7,13.78,13.78,0,0,1,.44-3.34,14.24,14.24,0,0,1,1.15-3.08,14.6,14.6,0,0,1,27.48,8.68,14.21,14.21,0,0,1-2,5.47l-.3.5-.32.44c-.22.28-.4.56-.6.79-.42.44-.74.85-1.06,1.13l-.71.62-.24.21a2.23,2.23,0,0,1,.22-.23l.69-.65c.3-.28.62-.69,1-1.14.2-.23.37-.51.58-.79l.32-.44.29-.5A14.37,14.37,0,1,0,94,200.2a14.19,14.19,0,0,0-1.12,3,13.6,13.6,0,0,0-.43,3.25A14.47,14.47,0,0,0,93.94,213l.06.13-.1.08-3.11,2.57.06-.15c.14,1.62.27,3.27.41,4.93l0,.27-.26-.09-4.49-1.56.18,0-2.86,2.36-1,.85.07-.15c.14,1.69.28,3.36.4,4.93l0,.27-.26-.09c-1.55-.53-3.08-1.06-4.49-1.56l.17,0-3.35,2.76.07-.15c.08,1,.17,2.06.24,3l0,.27-.26-.09-2.73-.95.16,0L71,232.16,71,232c-.19,1.57-.38,3.11-.56,4.51l-.11-.18L77,238.48l-.16,0,23.18-19,0,0,.07,0a14.48,14.48,0,0,0,12,.65,15.39,15.39,0,0,0,2.92-1.55l.69-.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.76,216.68a21.36,21.36,0,0,0,2.09-2.33,12.33,12.33,0,0,0,1.69-3.24,12.79,12.79,0,0,0,.7-4.77,12.53,12.53,0,0,0-1.57-5.59A12.7,12.7,0,0,0,113,196a11.91,11.91,0,0,0-3.35-1.36,16.1,16.1,0,0,0-1.84-.33,17.39,17.39,0,0,0-1.91,0,12.54,12.54,0,0,0-11.47,9.47,13.62,13.62,0,0,0-.34,1.87,13.16,13.16,0,0,0,0,1.88,11.66,11.66,0,0,0,.7,3.55,12.54,12.54,0,0,0,3.78,5.45,12.37,12.37,0,0,0,5.19,2.61,12.65,12.65,0,0,0,4.81.21,12.13,12.13,0,0,0,3.5-1,21.75,21.75,0,0,0,2.69-1.61l-.16.13-.47.38a6.66,6.66,0,0,1-.82.57,8.93,8.93,0,0,1-1.18.65,11.74,11.74,0,0,1-3.53,1.12,12.8,12.8,0,0,1-10.22-2.79,13,13,0,0,1-3.91-5.57,12.59,12.59,0,0,1-.73-3.64,13.84,13.84,0,0,1,0-1.93,14.46,14.46,0,0,1,.34-1.93,12.87,12.87,0,0,1,11.8-9.73,12.81,12.81,0,0,1,2,0,13.11,13.11,0,0,1,1.89.34,11.87,11.87,0,0,1,3.44,1.41,12.86,12.86,0,0,1,4.73,4.89,12.65,12.65,0,0,1,1.57,5.72,12.81,12.81,0,0,1-.77,4.84,12,12,0,0,1-1.77,3.26,8.05,8.05,0,0,1-.87,1,5,5,0,0,1-.71.69l-.46.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.79,206.38s.33-.3.77-.92a4.86,4.86,0,0,0,.87-3,4.71,4.71,0,0,0-2.35-3.86,4.58,4.58,0,0,0-2.65-.63,4.69,4.69,0,0,0-2.72,1.06,4.76,4.76,0,0,0-1.45,5.2,4.71,4.71,0,0,0,1.41,2,4.66,4.66,0,0,0,1.94,1,4.82,4.82,0,0,0,3.14-.28c.7-.31,1-.6,1-.57s-.07.08-.22.21a3.86,3.86,0,0,1-.76.49,4.92,4.92,0,0,1-5.33-.61,5,5,0,0,1-1.68-5.09,5,5,0,0,1,4.61-3.8,5,5,0,0,1,2.84.7,5,5,0,0,1,2.44,4.14,4.86,4.86,0,0,1-1,3.12,3.59,3.59,0,0,1-.62.65C114.89,206.32,114.8,206.39,114.79,206.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.21,237.73c-.06-.08,5.15-4.49,11.65-9.85s11.82-9.65,11.88-9.57-5.15,4.49-11.65,9.85S75.27,237.81,75.21,237.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.14,222.33a9.89,9.89,0,1,0,15.52-.13l1.69-2.17-1-3.22,3.23.36,2.11-2.72-1-3.22,3.22.37,1.82-2.34-.61-2,2,.22,1.68-.32-.38-3.95-5.29-.59-12.56,16.18A9.88,9.88,0,0,0,363.14,222.33Zm3.38,11.78a2.84,2.84,0,1,1,4-.51A2.84,2.84,0,0,1,366.52,234.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.52,234.11a2.84,2.84,0,1,1,4-.51A2.84,2.84,0,0,1,366.52,234.11Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,223.39a9.89,9.89,0,1,0,15.53-.13h0l1.69-2.17-1-3.22,3.22.37,2.11-2.72-1-3.22,3.22.36,1.82-2.34-.62-2,2,.22,1.05-1.36-.3-3.08-4.74-.41L374,219.89A9.91,9.91,0,0,0,363.64,223.39ZM367,235.16a2.84,2.84,0,1,1,4-.5A2.83,2.83,0,0,1,367,235.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,223.39a9.89,9.89,0,1,0,15.53-.13h0l1.69-2.17-1-3.22,3.22.37,2.11-2.72-1-3.22,3.22.36,1.82-2.34-.62-2,2,.22,1.05-1.36-.3-3.08-4.74-.41L374,219.89A9.91,9.91,0,0,0,363.64,223.39ZM367,235.16a2.84,2.84,0,1,1,4-.5A2.83,2.83,0,0,1,367,235.16Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,235.16s.21.14.62.31a2.77,2.77,0,0,0,1.83.1,2.73,2.73,0,1,0-3.45-2.68,2.84,2.84,0,0,0,.55,1.75c.26.35.47.5.45.52l-.15-.1a2.34,2.34,0,0,1-.38-.36,2.93,2.93,0,0,1,4.09-4.12,3,3,0,0,1,1,1.53,3,3,0,0,1,0,1.72,2.89,2.89,0,0,1-2.06,1.91,2.75,2.75,0,0,1-1.9-.18,2.48,2.48,0,0,1-.45-.27C367.06,235.21,367,235.17,367,235.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,223.39l.12-.16.37-.46a10.68,10.68,0,0,1,1.69-1.5,9.87,9.87,0,0,1,3.32-1.49,10,10,0,0,1,4.9,0l-.08,0,12.53-16.2,0-.05h.07l4.74.4h.09v.1c.1,1,.2,2,.31,3.08v.05l0,0-1.06,1.36,0,0h-.07l-2-.22.13-.15.61,2,0,.06,0,0-1.81,2.34,0,.05h-.07l-3.23-.36.14-.16c.31,1,.66,2.12,1,3.22l0,.06,0,.05c-.17.23-.37.48-.56.72l-1.55,2,0,.06h-.07l-3.22-.37.13-.15c.34,1.08.67,2.15,1,3.22l0,.06,0,0-1.69,2.17v-.15a10,10,0,0,1,2,4.24,9.86,9.86,0,0,1,.2,2.29,9.75,9.75,0,0,1-.31,2.23,10,10,0,0,1-17.81,3.29,9.9,9.9,0,0,1-1.78-5,9.56,9.56,0,0,1,.49-3.94l.12-.37.15-.35c.1-.21.18-.43.28-.61.22-.36.37-.68.54-.91l.38-.52a1.22,1.22,0,0,1,.13-.17,1.92,1.92,0,0,1-.11.18l-.36.54c-.17.23-.31.55-.52.91-.1.18-.17.39-.27.61l-.14.34-.12.38a9.8,9.8,0,1,0,18.8,5.53,9.24,9.24,0,0,0,.3-2.18,9.35,9.35,0,0,0-.2-2.23,9.93,9.93,0,0,0-1.95-4.14l-.05-.07.05-.08,1.69-2.17,0,.11-1-3.22-.05-.18.18,0,3.23.37-.11,0,1.55-2,.56-.72,0,.11c-.35-1.1-.69-2.2-1-3.22l-.06-.18.19,0,3.22.37-.11.05,1.82-2.34,0,.11-.61-2-.06-.18.19,0,2,.23-.11,0,1.06-1.36,0,.09c-.11-1.07-.21-2.13-.31-3.09l.11.1-4.74-.41.09,0-12.58,16.15,0,0H374a9.92,9.92,0,0,0-4.83-.08,10.15,10.15,0,0,0-3.3,1.44,11.18,11.18,0,0,0-1.71,1.47l-.38.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.66,224a14.36,14.36,0,0,0-1,1.87,8.14,8.14,0,0,0-.64,2.41,8.58,8.58,0,0,0,5.92,9.23,8.82,8.82,0,0,0,3.72.35,8.22,8.22,0,0,0,1.27-.27,8.57,8.57,0,0,0,4.43-3,8.66,8.66,0,0,0,1.8-5,11.21,11.21,0,0,0-.06-1.3,8.66,8.66,0,0,0-.26-1.25,8.07,8.07,0,0,0-1-2.26,8.58,8.58,0,0,0-7.18-4,8.58,8.58,0,0,0-3.23.58,8.13,8.13,0,0,0-2.18,1.22,12.86,12.86,0,0,0-1.55,1.47l.08-.11.26-.33a4.83,4.83,0,0,1,.46-.49,6.32,6.32,0,0,1,.69-.62,8.14,8.14,0,0,1,2.18-1.27,8.82,8.82,0,0,1,7.23.33,8.83,8.83,0,0,1,3.44,3.13,8.25,8.25,0,0,1,1,2.32,10.76,10.76,0,0,1,.27,1.28,11.91,11.91,0,0,1,.06,1.34,8.78,8.78,0,0,1-6.4,8.25,12.19,12.19,0,0,1-1.31.27,11.77,11.77,0,0,1-1.32.06,8.35,8.35,0,0,1-2.5-.43,8.76,8.76,0,0,1-5.78-6.13,8.64,8.64,0,0,1-.21-3.34,7.91,7.91,0,0,1,.69-2.43A6.87,6.87,0,0,1,364,225a4.74,4.74,0,0,1,.37-.57l.25-.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.18,230.87s-.17.24-.38.72a3.37,3.37,0,0,0-.12,2.15,3.17,3.17,0,0,0,2.14,2.22,3.18,3.18,0,0,0,1.86,0,3.24,3.24,0,0,0,2.33-3,3.19,3.19,0,0,0-.49-1.79,3.27,3.27,0,0,0-1.24-1.16,3.32,3.32,0,0,0-1.45-.37,3.26,3.26,0,0,0-2,.66c-.42.31-.59.56-.61.54s0-.07.12-.18a2.42,2.42,0,0,1,.43-.44,3.28,3.28,0,0,1,2.11-.75,3.39,3.39,0,0,1,2.87,1.57,3.43,3.43,0,0,1-.18,4,3.44,3.44,0,0,1-3.78,1.16,3.35,3.35,0,0,1-1.51-1,3.4,3.4,0,0,1-.73-1.39,3.32,3.32,0,0,1,.21-2.24A2.93,2.93,0,0,1,366,231C366.12,230.92,366.17,230.86,366.18,230.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.86,204.07c.05,0-2.76,3.75-6.29,8.3s-6.43,8.19-6.49,8.15,2.77-3.76,6.29-8.3S387.8,204,387.86,204.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.61,243.33l.69-1.32.74,1.29a6.2,6.2,0,0,0,2.52,2.43l1.32.69-1.29.74a6.27,6.27,0,0,0-2.43,2.52l-.69,1.32-.74-1.29a6.21,6.21,0,0,0-2.52-2.43l-1.32-.69,1.29-.74A6.14,6.14,0,0,0,122.61,243.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,266.84l.69-1.32.74,1.29a6.14,6.14,0,0,0,2.52,2.43l1.32.69-1.29.74a6.17,6.17,0,0,0-2.43,2.53l-.69,1.31-.74-1.29a6.23,6.23,0,0,0-2.53-2.43l-1.31-.69,1.29-.74A6.21,6.21,0,0,0,352.62,266.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,188.14l.69-1.31.74,1.29a6.21,6.21,0,0,0,2.52,2.43l1.32.69-1.29.74a6.14,6.14,0,0,0-2.43,2.52l-.69,1.32-.74-1.29a6.17,6.17,0,0,0-2.53-2.43l-1.31-.69,1.29-.74A6.23,6.23,0,0,0,355.52,188.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49,173.4l.69-1.32.74,1.3a6.27,6.27,0,0,0,2.52,2.43l1.32.68-1.29.74a6.17,6.17,0,0,0-2.43,2.53l-.69,1.32-.74-1.3a6.3,6.3,0,0,0-2.53-2.43l-1.31-.68,1.29-.74A6.23,6.23,0,0,0,122.49,173.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.92,196.34l.27-.51.28.5a2.4,2.4,0,0,0,1,.94l.51.27-.5.29a2.37,2.37,0,0,0-.94,1l-.26.51-.29-.5a2.46,2.46,0,0,0-1-.94l-.51-.26.5-.29A2.4,2.4,0,0,0,60.92,196.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.83,219.82l.27-.51.28.5a2.46,2.46,0,0,0,1,.94l.51.26-.5.29a2.44,2.44,0,0,0-.94,1l-.27.51-.28-.49a2.4,2.4,0,0,0-1-.94l-.51-.27.5-.29A2.37,2.37,0,0,0,402.83,219.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.28 436.91 72.28 465.5 114.08 465.5 160.19 465.5 160.19 436.91 72.28 436.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.59 428.92 68.59 436.91 163.26 436.91 163.26 428.92 114.08 428.92 68.59 428.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.93 465.5 160.19 465.5 160.19 436.91 163.26 436.91 163.26 428.92 114.08 428.92 114.08 436.17 115.93 465.5",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.58,
    y: 441.52,
    width: 17.83,
    height: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.28,
    y: 451.21,
    width: 22.89,
    height: 9.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.81 400.38 85.81 428.96 127.61 428.96 173.71 428.96 173.71 400.38 85.81 400.38",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.12 392.38 82.12 400.38 176.79 400.38 176.79 392.38 127.61 392.38 82.12 392.38",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.45 428.96 173.71 428.96 173.71 400.38 176.79 400.38 176.79 392.38 127.61 392.38 127.61 399.63 129.45 428.96",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: 404.98,
    width: 17.83,
    height: 4.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.81,
    y: 414.67,
    width: 22.89,
    height: 9.09,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.14,465.09c0,.15-79.76.26-178.13.26s-178.15-.11-178.15-.26,79.75-.26,178.15-.26S427.14,465,427.14,465.09Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Factors--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.55,211.54s0-.52-.07-1.54,0-2.55-.2-4.54a95.83,95.83,0,0,0-2.72-17.21,93.49,93.49,0,0,0-3.91-12A91.05,91.05,0,0,0,325,162.85a96.16,96.16,0,0,0-24.2-27.06A95,95,0,0,0,260.72,118a96.54,96.54,0,0,0-37.3.44,101.77,101.77,0,0,0-12.73,3.62,95.41,95.41,0,0,0-44.24,33.19,93.57,93.57,0,0,0-7.76,12.49c-1.17,2.18-2.17,4.45-3.2,6.73s-1.86,4.63-2.62,7a92.26,92.26,0,0,0-3.62,14.72,94.82,94.82,0,0,0,0,30.63,93.34,93.34,0,0,0,3.62,14.72c.76,2.4,1.71,4.72,2.63,7s2,4.55,3.19,6.73a94.21,94.21,0,0,0,7.76,12.49A95.49,95.49,0,0,0,210.69,301a100.15,100.15,0,0,0,12.73,3.63,96.34,96.34,0,0,0,37.3.43,95,95,0,0,0,40.09-17.78A96.53,96.53,0,0,0,325,260.23a91.86,91.86,0,0,0,6.63-13.42,93.72,93.72,0,0,0,6.63-29.19c.18-2,.14-3.51.2-4.53s.07-1.55.07-1.55,0,.53,0,1.55,0,2.55-.15,4.54a93.23,93.23,0,0,1-6.5,29.27,92.16,92.16,0,0,1-6.61,13.48A96.7,96.7,0,0,1,301,287.59a96.18,96.18,0,0,1-77.72,17.52,99.88,99.88,0,0,1-12.79-3.64A95.72,95.72,0,0,1,166,268.13a92.94,92.94,0,0,1-7.8-12.56c-1.18-2.19-2.19-4.48-3.22-6.76s-1.88-4.66-2.64-7.07a93.38,93.38,0,0,1-3.64-14.81,95.49,95.49,0,0,1,0-30.8,93.55,93.55,0,0,1,3.65-14.8c.76-2.41,1.72-4.74,2.64-7.07s2-4.57,3.21-6.76A94.55,94.55,0,0,1,166,155a95.88,95.88,0,0,1,44.49-33.34A101,101,0,0,1,223.32,118a96.7,96.7,0,0,1,37.48-.4A95.38,95.38,0,0,1,301,135.49a96.39,96.39,0,0,1,24.23,27.21,91.75,91.75,0,0,1,6.62,13.48,93.21,93.21,0,0,1,6.5,29.28c.17,2,.11,3.51.15,4.54S338.55,211.54,338.55,211.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,322.9c-.1-.1,11.05-11.54,24.91-25.53S169.4,272.1,169.5,272.2s-11.05,11.53-24.91,25.53S119.41,323,119.31,322.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.09,
    cy: 312.28,
    r: 30.69,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.78,312.28a4.93,4.93,0,0,1-.05-.5c0-.35-.06-.83-.1-1.46,0-.32,0-.68-.07-1.07s-.12-.82-.19-1.28a22,22,0,0,0-.65-3.16,29.08,29.08,0,0,0-3.4-8.13,30.68,30.68,0,0,0-7.77-8.65,30.33,30.33,0,0,0-12.83-5.68,28.52,28.52,0,0,0-3.85-.45c-.66,0-1.32-.08-2-.07l-2,.1c-.33,0-.67,0-1,.07l-1,.16c-.68.11-1.37.19-2,.33a32.26,32.26,0,0,0-4.06,1.19,31.54,31.54,0,0,0-4,1.75c-.64.35-1.25.75-1.89,1.13a15.07,15.07,0,0,0-1.84,1.27,35.18,35.18,0,0,0-3.45,2.93,33.88,33.88,0,0,0-3,3.53,29.54,29.54,0,0,0-4.35,8.38,30.14,30.14,0,0,0,0,19.2,29.34,29.34,0,0,0,4.35,8.39,27.64,27.64,0,0,0,6.43,6.46,15.07,15.07,0,0,0,1.84,1.27c.63.38,1.25.78,1.89,1.13a31.54,31.54,0,0,0,4,1.75,32.26,32.26,0,0,0,4.06,1.19c.69.14,1.38.22,2,.34l1,.15c.34.05.68.05,1,.07l2,.1c.67,0,1.33-.05,2-.07a28.52,28.52,0,0,0,3.85-.45,30.62,30.62,0,0,0,20.6-14.33,29.08,29.08,0,0,0,3.4-8.13,22,22,0,0,0,.65-3.16c.07-.46.15-.89.19-1.28s.05-.75.07-1.07c0-.62.07-1.11.1-1.46a4.45,4.45,0,0,1,.05-.49s0,.16,0,.49l-.05,1.46c0,.33,0,.69,0,1.08s-.11.83-.17,1.29a21.86,21.86,0,0,1-.6,3.19,29.31,29.31,0,0,1-3.35,8.23,30.92,30.92,0,0,1-20.77,14.61,29.41,29.41,0,0,1-3.91.46c-.66,0-1.33.09-2,.09l-2-.1c-.34,0-.69,0-1-.07l-1-.15c-.69-.12-1.39-.2-2.08-.34a32.82,32.82,0,0,1-4.13-1.2,31.15,31.15,0,0,1-4-1.77c-.65-.35-1.28-.76-1.93-1.14a16.69,16.69,0,0,1-1.86-1.29,36.4,36.4,0,0,1-3.52-3,35,35,0,0,1-3-3.59A29.64,29.64,0,0,1,97.75,322a30.6,30.6,0,0,1,0-19.53,29.52,29.52,0,0,1,4.43-8.52,35,35,0,0,1,3-3.59,36.4,36.4,0,0,1,3.52-3,15.93,15.93,0,0,1,1.87-1.29c.64-.38,1.27-.79,1.92-1.14a31.15,31.15,0,0,1,4-1.77,32.82,32.82,0,0,1,4.13-1.2c.69-.14,1.39-.22,2.08-.33l1-.16c.34,0,.69,0,1-.06l2-.1c.67,0,1.35.05,2,.08a29.41,29.41,0,0,1,3.91.46,30.92,30.92,0,0,1,20.77,14.61,29.31,29.31,0,0,1,3.35,8.23,21.86,21.86,0,0,1,.6,3.19c.06.47.14.89.17,1.29s0,.75,0,1.08c0,.62,0,1.11.05,1.46S157.78,312.28,157.78,312.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,170.79c-.07-.12,9-5.58,20.24-12.19s20.43-11.86,20.5-11.74-9,5.58-20.24,12.19S329.5,170.91,329.42,170.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.28,
    cy: 141.38,
    r: 30.69,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,141.38s0-.17,0-.5,0-.83.05-1.46c0-.32,0-.68,0-1.08s.11-.82.17-1.29a21.86,21.86,0,0,1,.6-3.19,29.15,29.15,0,0,1,3.35-8.22A30.83,30.83,0,0,1,370.57,111a27.85,27.85,0,0,1,3.91-.47c.66,0,1.34-.09,2-.08l2.05.1c.34,0,.69,0,1,.06l1,.16c.69.11,1.39.19,2.08.33a34.59,34.59,0,0,1,4.13,1.2,34.15,34.15,0,0,1,4,1.77c.65.35,1.28.76,1.92,1.15a14.73,14.73,0,0,1,1.87,1.28,28.07,28.07,0,0,1,6.55,6.56,29.78,29.78,0,0,1,4.43,8.52,30.6,30.6,0,0,1,0,19.53,29.7,29.7,0,0,1-4.43,8.53,36,36,0,0,1-3,3.58,34.05,34.05,0,0,1-3.52,3,15.37,15.37,0,0,1-1.86,1.28c-.65.38-1.28.8-1.93,1.15a34.15,34.15,0,0,1-4,1.77,34.59,34.59,0,0,1-4.13,1.2c-.69.14-1.39.22-2.08.33l-1,.16c-.34,0-.69,0-1,.06l-2.05.1c-.68,0-1.35-.06-2-.08a27.85,27.85,0,0,1-3.91-.47,30.83,30.83,0,0,1-20.77-14.61,29.15,29.15,0,0,1-3.35-8.22,21.86,21.86,0,0,1-.6-3.19c-.06-.47-.14-.9-.17-1.29s0-.76,0-1.08l-.05-1.46c0-.33,0-.5,0-.5a4.93,4.93,0,0,1,.05.5c0,.35.06.83.1,1.45,0,.32,0,.68.07,1.07s.12.82.19,1.28a22.1,22.1,0,0,0,.65,3.17,29.16,29.16,0,0,0,3.4,8.12,30.67,30.67,0,0,0,20.6,14.34,27,27,0,0,0,3.85.44c.66,0,1.32.09,2,.08l2-.11c.34,0,.68,0,1-.06l1-.16c.68-.11,1.36-.19,2-.33a32.32,32.32,0,0,0,4.06-1.2,31.47,31.47,0,0,0,4-1.74c.64-.35,1.26-.76,1.89-1.14a16.19,16.19,0,0,0,1.84-1.26,32.91,32.91,0,0,0,3.45-2.94,33.88,33.88,0,0,0,3-3.53,29.29,29.29,0,0,0,4.35-8.38,30.14,30.14,0,0,0,0-19.2,29.6,29.6,0,0,0-4.35-8.39,34.83,34.83,0,0,0-3-3.52,34,34,0,0,0-3.45-2.94,17.7,17.7,0,0,0-1.84-1.27c-.64-.37-1.25-.78-1.89-1.13a31.47,31.47,0,0,0-4-1.74,32.32,32.32,0,0,0-4.06-1.2c-.68-.14-1.37-.22-2-.33l-1-.16c-.34,0-.68,0-1-.06l-2-.11c-.67,0-1.33,0-2,.08a27,27,0,0,0-3.85.44,30.71,30.71,0,0,0-20.6,14.33,29.2,29.2,0,0,0-3.4,8.13,22.1,22.1,0,0,0-.65,3.17c-.06.46-.15.88-.19,1.28l-.07,1.07c0,.62-.07,1.1-.1,1.45A4.93,4.93,0,0,1,345.59,141.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.93,325.62c-.11.1-11.67-11.42-25.84-25.73s-25.57-26-25.47-26.1,11.67,11.42,25.84,25.73S367,325.52,366.93,325.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,132.43a10.44,10.44,0,0,1,2.57-1.12l.53-2.55,4.31-.07.62,2.52a11,11,0,0,1,2.61,1l2.18-1.42,3.1,3L385.33,136a10.9,10.9,0,0,1,1.12,2.58l2.55.53.07,4.3-2.53.62a10.48,10.48,0,0,1-1,2.62l1.42,2.17-3,3.1-2.22-1.35a10.14,10.14,0,0,1-2.58,1.12l-.53,2.55-4.31.08-.62-2.53a10.59,10.59,0,0,1-2.61-1l-2.17,1.43-3.1-3,1.35-2.23a10.08,10.08,0,0,1-1.12-2.57l-2.55-.54-.08-4.3,2.53-.62a10.59,10.59,0,0,1,1-2.61l-1.43-2.18,3-3.1,2.23,1.35Zm2.29,5.74a4.62,4.62,0,1,0,6.54-.12A4.62,4.62,0,0,0,373.05,138.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.05,138.17a3.75,3.75,0,0,1,.87-.76,4.66,4.66,0,0,1,5.06,0,4.68,4.68,0,0,1,1.65,1.86,4.42,4.42,0,0,1,.43,1.3,4.5,4.5,0,0,1,0,1.42,4.69,4.69,0,0,1-3.9,4,4.52,4.52,0,0,1-1.42,0,4.41,4.41,0,0,1-1.31-.38,4.68,4.68,0,0,1-2.73-3.61,4.62,4.62,0,0,1,.61-3,3.43,3.43,0,0,1,.72-.88s-.27.3-.63.93a4.59,4.59,0,0,0-.51,3,4.46,4.46,0,0,0,.79,1.92,4.52,4.52,0,0,0,1.85,1.5,4.22,4.22,0,0,0,1.24.35,4.38,4.38,0,0,0,1.35,0,4.48,4.48,0,0,0,3.68-3.82,4.36,4.36,0,0,0,0-1.35,4.31,4.31,0,0,0-.39-1.23,4.57,4.57,0,0,0-1.56-1.79,4.73,4.73,0,0,0-1.95-.73,4.61,4.61,0,0,0-2.94.62C373.35,137.88,373.08,138.19,373.05,138.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,132.43l-.14-.08-.43-.24-1.68-1h.05l-3,3.12v-.09l1.43,2.17,0,0,0,0a10.2,10.2,0,0,0-1,2.6l0,0H366l-2.53.63.08-.09c0,1.35.05,2.79.08,4.3l-.08-.1,2.55.53h.06l0,.07a10.79,10.79,0,0,0,1.11,2.54l0,.06,0,.06-1.34,2.23,0-.15,3.1,3-.15,0,2.17-1.42.07-.05.06,0a10.27,10.27,0,0,0,2.59,1l.07,0,0,.08c.19.79.41,1.65.62,2.53l-.13-.1,4.31-.08-.13.1c.17-.8.35-1.67.53-2.54l0-.08.08,0a10.84,10.84,0,0,0,2.54-1.11h0l.07,0,.07,0,2.22,1.35-.16,0,3-3.1,0,.17-1.42-2.18-.05-.07,0-.07a10.35,10.35,0,0,0,1-2.58l0-.07.07,0,2.53-.62-.09.13c0-1.47-.05-2.91-.07-4.31l.09.12-2.55-.54h-.07l0-.07a10.19,10.19,0,0,0-1.1-2.55l0-.06,0-.06q.7-1.14,1.35-2.22l0,.14-3.09-3h.13l-2.18,1.42,0,0-.05,0a10.28,10.28,0,0,0-2.59-1h0v0c-.23-.92-.43-1.75-.61-2.54l.07.06-4.3.06.05,0c-.22,1-.39,1.85-.54,2.55v0h0a10.55,10.55,0,0,0-2,.76l-.47.24-.15.08.14-.1.46-.26a10.2,10.2,0,0,1,2-.8l0,0,.52-2.55v-.05h0l4.31-.09h.06l0,.06c.19.78.4,1.61.63,2.52l-.07-.06a10.59,10.59,0,0,1,2.64,1h-.1l2.17-1.43.07,0,.06.05,3.11,3,.06.06-.05.07c-.43.73-.88,1.47-1.34,2.23V136a10.52,10.52,0,0,1,1.13,2.61l-.09-.09L389,139l.1,0v.1c0,1.4.05,2.83.08,4.3v.1l-.1,0-2.52.62.09-.09a10.44,10.44,0,0,1-1,2.64v-.13l1.42,2.17.06.09L387,149c-1,1-2,2.05-3,3.09l-.08.08-.09-.05-2.22-1.35h.13a11,11,0,0,1-2.6,1.13l.09-.1-.53,2.55,0,.1h-.11l-4.3.08h-.11l0-.1c-.22-.87-.43-1.74-.62-2.53l.09.09a10.46,10.46,0,0,1-2.64-1h.13L369,152.32l-.08.05-.07-.06-3.1-3-.06-.07,0-.08,1.35-2.22v.12a10.53,10.53,0,0,1-1.13-2.61l.08.08-2.54-.53-.09,0v-.08c0-1.51,0-3-.06-4.31v-.08h.07l2.53-.62-.06.07a10.69,10.69,0,0,1,1-2.63v.08l-1.41-2.18,0-.05,0,0,3-3.08,0,0h0l1.63,1,.43.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.68,
    cy: 315.71,
    r: 30.69,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,315.71s0-.17,0-.5,0-.84.05-1.46c0-.32,0-.68,0-1.08s.11-.82.17-1.29a23.29,23.29,0,0,1,.6-3.19,29.07,29.07,0,0,1,3.36-8.23A30.85,30.85,0,0,1,353,285.35a29.07,29.07,0,0,1,3.9-.46c.67,0,1.34-.09,2-.08l2,.1c.34,0,.69,0,1,.06l1,.16c.68.11,1.38.19,2.08.33a32.68,32.68,0,0,1,4.12,1.2,31.94,31.94,0,0,1,4,1.77c.65.35,1.28.76,1.93,1.15a15.47,15.47,0,0,1,1.87,1.28,35,35,0,0,1,3.51,3,33.7,33.7,0,0,1,3,3.58,29.64,29.64,0,0,1,4.43,8.52,30.69,30.69,0,0,1,0,19.53A30,30,0,0,1,383.6,334a28.37,28.37,0,0,1-6.55,6.57,16.72,16.72,0,0,1-1.87,1.28c-.65.38-1.28.79-1.93,1.15a31.87,31.87,0,0,1-4,1.76,31.1,31.1,0,0,1-4.12,1.2c-.7.15-1.4.23-2.09.34l-1,.15c-.34.05-.69.05-1,.07l-2.05.1c-.67,0-1.34-.06-2-.08a29.41,29.41,0,0,1-3.91-.47,30.92,30.92,0,0,1-20.77-14.61,29.31,29.31,0,0,1-3.35-8.23,22.74,22.74,0,0,1-.6-3.19c-.06-.46-.13-.89-.17-1.29s0-.75,0-1.07l-.05-1.46c0-.33,0-.5,0-.5a4.9,4.9,0,0,1,.05.49c0,.35.06.84.1,1.46l.07,1.07c0,.39.13.82.2,1.28a23,23,0,0,0,.64,3.16,29.38,29.38,0,0,0,3.4,8.13,30.67,30.67,0,0,0,20.6,14.34,28.67,28.67,0,0,0,3.86.44c.65,0,1.31.09,2,.08l2-.11c.34,0,.68,0,1-.06l1-.16c.68-.11,1.37-.19,2.05-.33a31.83,31.83,0,0,0,4.06-1.2,31.47,31.47,0,0,0,4-1.74c.64-.35,1.26-.76,1.89-1.14a15.35,15.35,0,0,0,1.84-1.26,28.25,28.25,0,0,0,6.44-6.47,29.54,29.54,0,0,0,4.35-8.38,30.26,30.26,0,0,0,0-19.21,29.42,29.42,0,0,0-4.35-8.38,34.75,34.75,0,0,0-3-3.53,34,34,0,0,0-3.45-2.93,14.34,14.34,0,0,0-1.84-1.27c-.63-.38-1.25-.78-1.89-1.13a33.06,33.06,0,0,0-4-1.75,33.49,33.49,0,0,0-4.06-1.19c-.68-.14-1.37-.22-2.05-.33l-1-.16c-.34,0-.68,0-1-.07l-2-.1c-.66,0-1.33.05-2,.08a27.13,27.13,0,0,0-3.86.44,30.57,30.57,0,0,0-20.59,14.33,29.26,29.26,0,0,0-3.41,8.13,23.59,23.59,0,0,0-.64,3.16c-.07.47-.16.89-.2,1.28s0,.75-.07,1.08c0,.62-.07,1.1-.1,1.45A4.93,4.93,0,0,1,328,315.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,317.05a5.69,5.69,0,0,0,3.39-5.27,5.35,5.35,0,1,0-10.68,0,5.68,5.68,0,0,0,3.41,5.32c-8.22,1.24-7.85,10.17-7.85,10.17l19.43.09S369,318.28,360.81,317.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.86,311a3.54,3.54,0,0,0,2.12-3.3,3.35,3.35,0,1,0-6.69,0,3.56,3.56,0,0,0,2.14,3.33c-5.15.78-4.92,6.37-4.92,6.37l12.17.05S378,311.76,372.86,311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,311a3.54,3.54,0,0,0,2.12-3.3,3.35,3.35,0,1,0-6.68,0,3.55,3.55,0,0,0,2.13,3.33c-5.15.78-4.92,6.37-4.92,6.37l12.17.05S352.12,311.76,347,311Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.31,157.81c-.09.12-9.4-6.54-20.8-14.86S122.93,127.78,123,127.66s9.39,6.54,20.8,14.87S164.39,157.69,164.31,157.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.17,
    y: 313.99,
    width: 7.08,
    height: 8.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.39,
    y: 308.82,
    width: 7.08,
    height: 13.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.94,
    y: 302.44,
    width: 7.08,
    height: 19.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.91,
    cy: 122.18,
    r: 30.69,
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.59,122.18a4.93,4.93,0,0,1-.05-.5c0-.35-.06-.83-.1-1.45,0-.32,0-.68-.07-1.07s-.12-.82-.19-1.28a22.1,22.1,0,0,0-.65-3.17,29.33,29.33,0,0,0-3.4-8.13,30.71,30.71,0,0,0-20.6-14.33,27,27,0,0,0-3.85-.44c-.66,0-1.32-.09-2-.08l-2,.11c-.34,0-.68,0-1,.06l-1,.16c-.68.11-1.36.19-2,.33a32.32,32.32,0,0,0-4.06,1.2,31.47,31.47,0,0,0-4,1.74c-.64.35-1.25.76-1.89,1.13a17.7,17.7,0,0,0-1.84,1.27,34,34,0,0,0-3.45,2.94,34.83,34.83,0,0,0-3,3.52,29.6,29.6,0,0,0-4.35,8.39,30.14,30.14,0,0,0,0,19.2,29.29,29.29,0,0,0,4.35,8.38,33.88,33.88,0,0,0,3,3.53,32.91,32.91,0,0,0,3.45,2.94,17.7,17.7,0,0,0,1.84,1.27c.64.37,1.25.78,1.89,1.13a31.47,31.47,0,0,0,4,1.74,32.32,32.32,0,0,0,4.06,1.2c.69.14,1.38.22,2,.33l1,.16c.34,0,.68,0,1,.06l2,.11c.67,0,1.33,0,2-.08a27,27,0,0,0,3.85-.44,30.67,30.67,0,0,0,20.6-14.34,29.16,29.16,0,0,0,3.4-8.12,22.1,22.1,0,0,0,.65-3.17c.07-.46.15-.88.19-1.28l.07-1.07c0-.62.07-1.1.1-1.45a4.93,4.93,0,0,1,.05-.5s0,.17,0,.5l-.05,1.46c0,.32,0,.68,0,1.08s-.11.82-.17,1.29a21.86,21.86,0,0,1-.6,3.19,29.15,29.15,0,0,1-3.35,8.22,30.83,30.83,0,0,1-20.77,14.61,27.85,27.85,0,0,1-3.91.47c-.66,0-1.33.09-2,.08l-2-.1c-.34,0-.69,0-1-.06l-1-.16c-.69-.11-1.39-.19-2.08-.33a34.59,34.59,0,0,1-4.13-1.2,34.15,34.15,0,0,1-4-1.77c-.65-.35-1.28-.76-1.93-1.15A15.37,15.37,0,0,1,98.54,147a35.14,35.14,0,0,1-3.52-3,36,36,0,0,1-3-3.58,29.7,29.7,0,0,1-4.43-8.53,30.6,30.6,0,0,1,0-19.53A29.78,29.78,0,0,1,92,103.89a36,36,0,0,1,3-3.58,35.14,35.14,0,0,1,3.52-3,14.73,14.73,0,0,1,1.87-1.28c.64-.39,1.27-.8,1.92-1.15a34.15,34.15,0,0,1,4-1.77,34.59,34.59,0,0,1,4.13-1.2c.69-.14,1.39-.22,2.08-.33l1-.16c.34,0,.69,0,1-.06l2-.1c.67,0,1.35.06,2,.08a27.85,27.85,0,0,1,3.91.47,30.83,30.83,0,0,1,20.77,14.61,29.15,29.15,0,0,1,3.35,8.22,21.86,21.86,0,0,1,.6,3.19c.06.47.14.9.17,1.29s0,.76,0,1.08c0,.63,0,1.11.05,1.46S147.59,122.18,147.59,122.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,118.47a10.19,10.19,0,1,0-14.53,9.22v2.57h8.93s.06-1.45.08-2.73A10.2,10.2,0,0,0,127.09,118.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.26,130.21a.55.55,0,0,0,0-.12l0-.37c0-.32.09-.8.18-1.41s.21-1.36.41-2.21a15.49,15.49,0,0,1,.92-2.84,10.54,10.54,0,0,1,.84-1.53,1.92,1.92,0,0,1,.7-.62,1.07,1.07,0,0,1,1,0,.75.75,0,0,1,.32.4.8.8,0,0,1,0,.53,1.45,1.45,0,0,1-.79.67,2.8,2.8,0,0,1-2.12-.14,2.86,2.86,0,0,1-1.44-1.71,2.11,2.11,0,0,1-.06-1.17.92.92,0,0,1,.93-.71.68.68,0,0,1,.52.36,1,1,0,0,1,.08.63,2,2,0,0,1-.72,1,3,3,0,0,1-2.37.69,2.64,2.64,0,0,1-2-1.47,1.51,1.51,0,0,1-.07-1.23.75.75,0,0,1,.44-.45.77.77,0,0,1,.63,0,1,1,0,0,1,.43.45,1.58,1.58,0,0,1,.16.59,2.84,2.84,0,0,1-.16,1.16,3,3,0,0,1-1.43,1.71,3.07,3.07,0,0,1-2.11.29,1.62,1.62,0,0,1-.92-.48.8.8,0,0,1-.06-1,.69.69,0,0,1,.46-.22,1,1,0,0,1,.49.09,1.5,1.5,0,0,1,.62.7c.26.56.46,1.09.67,1.61.82,2,1.39,3.74,1.78,4.91.19.59.34,1.05.43,1.36,0,.15.08.27.11.35l0,.13a.64.64,0,0,1,0-.12l-.12-.35-.46-1.35c-.4-1.17-1-2.85-1.81-4.9-.21-.51-.42-1.05-.68-1.59a1.32,1.32,0,0,0-.58-.65.61.61,0,0,0-.76,1,1.55,1.55,0,0,0,.86.44,3,3,0,0,0,2-.28,2.91,2.91,0,0,0,1.38-1.65,3,3,0,0,0,.15-1.11,1.14,1.14,0,0,0-.53-.94.67.67,0,0,0-.52,0,.64.64,0,0,0-.38.39,1.4,1.4,0,0,0,.07,1.13,2.51,2.51,0,0,0,1.88,1.4,2.92,2.92,0,0,0,2.27-.66,1.94,1.94,0,0,0,.68-1,.84.84,0,0,0-.07-.54.58.58,0,0,0-.43-.3.73.73,0,0,0-.5.17.84.84,0,0,0-.29.45,2,2,0,0,0,.06,1.11,2.68,2.68,0,0,0,3.4,1.78,1.32,1.32,0,0,0,.73-.62.6.6,0,0,0-.24-.79,1,1,0,0,0-.87,0,1.79,1.79,0,0,0-.66.59,9.87,9.87,0,0,0-.84,1.51,15.34,15.34,0,0,0-.93,2.81c-.2.85-.33,1.6-.43,2.21s-.16,1.08-.21,1.4c0,.16,0,.28,0,.37Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81,131.91h-7.67a.58.58,0,0,1-.58-.58h0a.58.58,0,0,1,.58-.57h7.67a.58.58,0,0,1,.57.57h0A.58.58,0,0,1,120.81,131.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81,132.41h-7.67a.58.58,0,0,0-.58.58.57.57,0,0,0,.58.57H114l1.12,2.13a.73.73,0,0,0,.65.39h2.74a.74.74,0,0,0,.66-.4l1.08-2.12h.58a.57.57,0,0,0,.57-.57A.58.58,0,0,0,120.81,132.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,135.86a5.22,5.22,0,0,1-.53-.16,4.3,4.3,0,0,0-1.3-.16,4,4,0,0,0-1.29.24,5.16,5.16,0,0,1-.52.19,1.85,1.85,0,0,1,.49-.28,3.94,3.94,0,0,1,1.32-.28,3.78,3.78,0,0,1,1.33.21A1.71,1.71,0,0,1,119,135.86Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.25,133.59s-1.39.06-3.09.06-3.1,0-3.1-.06,1.38-.06,3.1-.06S120.25,133.55,120.25,133.59Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.77,134.5a3.88,3.88,0,0,1-.75.08c-.47,0-1.12,0-1.83.06s-1.36,0-1.83,0a4.14,4.14,0,0,1-.76-.06,4,4,0,0,1,.76,0l1.83,0,1.82,0A4.19,4.19,0,0,1,119.77,134.5Z",
    style: {
      fill: "#06EB83"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.08,432.92l1.72,28.73-5.19,23.12a3,3,0,0,0,2.43,3.56h0a2.92,2.92,0,0,0,2.56-.85c4.24-4.38,19.46-20.4,19.4-22.19-.08-2.33.28-30.88.28-30.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,488.33,246,462l.06,2.14c0,1.18.07,1.8-.59,2.63a243.93,243.93,0,0,1-18.53,21.17c-.68.71-1.93.59-2.9.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.77,453.84a1.78,1.78,0,0,0-.4,2.35,1.72,1.72,0,0,0,2.32.42,1.89,1.89,0,0,0,.41-2.49,1.79,1.79,0,0,0-2.46-.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.15,475.52c-.16.09-.86-1.4-2.6-2.14a8.83,8.83,0,0,0-3.34-.51c0-.07.33-.31,1-.43a4.71,4.71,0,0,1,4.59,2.05C230.16,475.07,230.22,475.5,230.15,475.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.25,479.45c-.14.13-1.09-.77-2.6-1.14s-2.77-.08-2.82-.26,1.27-.81,3-.35S228.39,479.37,228.25,479.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.78,470.44c-.13.14-1.59-1.25-3.88-2s-4.29-.65-4.31-.84,2.07-.63,4.52.24S233.92,470.36,233.78,470.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,461.66c-.07.18-1.69-.43-3.76-.42s-3.69.56-3.76.38,1.54-1,3.77-1A5.82,5.82,0,0,1,234,461.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.69,453.22c-.08.17-1.71-.73-3.89-.55s-3.67,1.25-3.78,1.1.25-.43.9-.84a6.46,6.46,0,0,1,5.76-.42C233.38,452.83,233.73,453.15,233.69,453.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,451.06a2.36,2.36,0,0,1-.08-1.09,7.54,7.54,0,0,1,.76-2.88,3.29,3.29,0,0,1,1.38-1.65,1.17,1.17,0,0,1,1.34.21,1.91,1.91,0,0,1,.5,1.28,4.16,4.16,0,0,1-3.5,4,4.82,4.82,0,0,1-4.84-2.35,1.67,1.67,0,0,1-.14-1.39,1.17,1.17,0,0,1,1.2-.66,4.14,4.14,0,0,1,1.93.91,8.42,8.42,0,0,1,2,2.17c.38.59.51,1,.47,1a13,13,0,0,0-2.78-2.77,3.85,3.85,0,0,0-1.7-.76.61.61,0,0,0-.65.36,1.11,1.11,0,0,0,.14.91,4.32,4.32,0,0,0,4.22,2,3.62,3.62,0,0,0,3-3.35,1.41,1.41,0,0,0-.31-.91.64.64,0,0,0-.74-.12,3,3,0,0,0-1.19,1.37A11.09,11.09,0,0,0,229.79,451.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.44,427.92l-1,23.78s23.84,9,24.08,13.39l-46.16-.25V427.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.19,449.62a1.88,1.88,0,0,0-1.32,2.14,1.81,1.81,0,0,0,2.12,1.32,2,2,0,0,0,1.38-2.28,1.89,1.89,0,0,0-2.35-1.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37,464.84v-3.38l44.5,1.29s1.57,1.06,1.66,2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.2,451.46c0,.23-1.14.33-2.25,1s-1.71,1.67-1.92,1.58.14-1.39,1.5-2.24S289.25,451.26,289.2,451.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,453.49c.05.22-.93.6-1.7,1.55s-1,2-1.22,1.95-.36-1.29.62-2.45S294,453.28,294,453.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,459.3c-.21.05-.51-1.08.07-2.31s1.65-1.71,1.74-1.53-.56.85-1,1.87S297,459.28,296.75,459.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.82,446c-.09.21-1.12-.11-2.4,0s-2.27.48-2.39.28.85-1,2.35-1.06S288.94,445.84,288.82,446Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.1,99.93l1.38-7.87S308.75,82,309.16,80.62s1.31-8.1,1.31-8.1l7.49-7a2.43,2.43,0,0,1,2.17,1.62s3.12,0,3.62,2.19A1.78,1.78,0,0,1,326.23,71a8.68,8.68,0,0,1,0,2c.43.14,2.94,1,2.85,2.28a20,20,0,0,1-1.61,5.65,2.16,2.16,0,0,1-1.69,1.16h0l-1.08,3.41s-1.2,5.65-2.73,8.2l-1.11,1.49-1,7.72A19.61,19.61,0,0,1,309.1,99.93Z",
    style: {
      fill: "#b06b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,72.08A13.76,13.76,0,0,0,320,66.82l-2.75,1.41a17.14,17.14,0,0,0,.82,2.68,3.4,3.4,0,0,0,2,2.28,1.23,1.23,0,0,0,1.55-.43A1.55,1.55,0,0,0,321.65,72.08Z",
    style: {
      fill: "#b06b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,68.23a1.52,1.52,0,0,0,.06.55,11.6,11.6,0,0,0,.44,1.43c.1.31.2.63.32,1a3.92,3.92,0,0,0,.57,1.06,3,3,0,0,0,1,.89,1.81,1.81,0,0,0,1.43.18,1,1,0,0,0,.59-.51,1.44,1.44,0,0,0,.08-.73,9,9,0,0,0-.18-1.31,12.13,12.13,0,0,0-.66-2.12c-.24-.59-.47-1-.63-1.36a3.64,3.64,0,0,0-.28-.47,2.18,2.18,0,0,0,.2.51c.14.32.35.79.57,1.37a14.77,14.77,0,0,1,.6,2.11,10.39,10.39,0,0,1,.17,1.28,1.29,1.29,0,0,1-.07.63.7.7,0,0,1-.46.39,1.59,1.59,0,0,1-1.26-.16,2.93,2.93,0,0,1-.95-.82,3.84,3.84,0,0,1-.56-1c-.13-.34-.23-.68-.35-1-.22-.59-.4-1.06-.49-1.4S317.26,68.23,317.25,68.23Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,73.25a.47.47,0,0,0,0,.15,2.27,2.27,0,0,0,0,.44,3.84,3.84,0,0,0,.28,1.61,5,5,0,0,0,1.41,2,1.83,1.83,0,0,0,1.39.44,1.32,1.32,0,0,0,.73-.35,1.27,1.27,0,0,0,.34-.76,7,7,0,0,0-.12-1.54c-.07-.49-.15-1-.24-1.4-.19-.88-.36-1.67-.5-2.35s-.24-1.22-.3-1.59a3.5,3.5,0,0,0-.12-.59,3,3,0,0,0,0,.6c0,.38.12.93.24,1.61s.28,1.48.45,2.36c.08.44.16.91.23,1.39a6.76,6.76,0,0,1,.11,1.49,1.08,1.08,0,0,1-.28.63,1,1,0,0,1-.6.29,1.63,1.63,0,0,1-1.24-.39,5.09,5.09,0,0,1-1.39-1.87,4.54,4.54,0,0,1-.34-1.55A5.42,5.42,0,0,0,321,73.25Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.27,77.07a.87.87,0,0,0-.08.17,3.74,3.74,0,0,0-.16.5,6,6,0,0,0-.18,1.93,4.28,4.28,0,0,0,1,2.67,2.32,2.32,0,0,0,1.52.8,1.24,1.24,0,0,0,.91-.3,1.79,1.79,0,0,0,.45-.86,23.34,23.34,0,0,0,.26-3.51c0-1.07,0-2,0-2.86s0-1.47.07-1.92a6.26,6.26,0,0,0,0-.71s0,.06,0,.18-.05.29-.07.52c-.06.45-.11,1.11-.14,1.93s-.05,1.79-.09,2.85a25.41,25.41,0,0,1-.28,3.47,1.42,1.42,0,0,1-.38.75,1,1,0,0,1-.75.25A2.18,2.18,0,0,1,323,82.2a4.21,4.21,0,0,1-1-2.54A7.93,7.93,0,0,1,322.27,77.07Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,66S160.64,51.66,159,44.48c-1.57-7-3.48-18.92-3.48-18.92s-1.85-.26-2.38,6.33-.56,10.87-.56,10.87l-10.25-9.28a4.17,4.17,0,0,0,0,5c1.85,2.9,8.42,10.34,8.42,10.34l-2.35,2.05s-5.6-3.43-6.89-.53,5,4,5,4l.26,4.22L150,61.69l2.37.79s3.51,4.67,4.83,6a22.89,22.89,0,0,1,2.82,4Z",
    style: {
      fill: "#b06b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,51.16a16.9,16.9,0,0,1-4.18.05,16.65,16.65,0,0,1-4.17-.46,17.27,17.27,0,0,1,4.19-.06A16.78,16.78,0,0,1,156.73,51.16Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,61.56a2.22,2.22,0,0,1-1.73-.1,5.25,5.25,0,0,1-1.62-1,9,9,0,0,1-1.45-1.79,28.09,28.09,0,0,0-2.23-3.39c-.66-.77-1.23-1.1-1.19-1.17s.68.16,1.46.92a17.65,17.65,0,0,1,2.39,3.35,6.92,6.92,0,0,0,2.78,2.74A8.87,8.87,0,0,0,154.64,61.56Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,46.14c-.14,0-.42-.65-.64-1.53s-.27-1.62-.13-1.65.42.65.64,1.53S153.19,46.11,153.05,46.14Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.74,99.29s-8.54,16.78-11.63,29.29l-1,4.16s8.65,10.95,17.34,13.36l11.24-16.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.06,120.12c-.16-9.11,1.21-19.37-4.8-26.56-4.46-5.34-10.32-7.81-17.18-9-3.37-.57-7.48.17-10.75,1.2-4.48,1.42-7.15,5.65-10,9.41-5.64,7.53-7.56,18.94-5.61,22.64l31,25.86c7.74-2.15,12.42-2.67,15.51-11.72A34.87,34.87,0,0,0,273.06,120.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,100.29,245.45,89.14c-6.86-2.53-13.75,5-16,11.91-2.49,7.73-5.23,17.27-5.79,23.37-1.12,12.26,7.53,16.06,7.53,16.06s0,.18-.84,3.7l-1.45,5.68a10.15,10.15,0,0,0,.56,6.89c2.35,4.89,8.13,6.7,15.65,5.61,4.35-.64,7.79-3.05,9-7.07l14.59-49.85A4.28,4.28,0,0,0,266,100.29Z",
    style: {
      fill: "#b06b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,112.77a1.55,1.55,0,0,0,1.07,1.89,1.49,1.49,0,0,0,1.91-1,1.56,1.56,0,0,0-1.07-1.9A1.5,1.5,0,0,0,231.21,112.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,108.61c.14.25,1.5-.31,3.13.11s2.61,1.53,2.83,1.38,0-.47-.41-1a4.33,4.33,0,0,0-2.21-1.34,4,4,0,0,0-2.55.16C230,108.19,229.7,108.5,229.77,108.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.53,115.87a1.55,1.55,0,0,0,1.07,1.89,1.49,1.49,0,0,0,1.91-1,1.57,1.57,0,0,0-1.07-1.9A1.5,1.5,0,0,0,246.53,115.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,112.23c.14.25,1.5-.31,3.12.11s2.61,1.53,2.84,1.38,0-.47-.41-1a4.28,4.28,0,0,0-2.21-1.35,4.17,4.17,0,0,0-2.55.16C246.06,111.81,245.8,112.12,245.87,112.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.22,121.51a11.47,11.47,0,0,0-2.52-1.15c-.41-.14-.78-.33-.78-.63a2.23,2.23,0,0,1,.59-1.16c.65-.9,1.32-1.85,2-2.85,2.85-4.07,5-7.46,4.86-7.57s-2.6,3.09-5.45,7.16l-2,2.88a2.51,2.51,0,0,0-.63,1.58,1.06,1.06,0,0,0,.53.78,3.07,3.07,0,0,0,.68.28A10.73,10.73,0,0,0,237.22,121.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.2,140.48a31,31,0,0,0,16.86-.2s-6,7.26-17.52,3.16Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,125.91a2.71,2.71,0,0,0-1.87-1.73,3.49,3.49,0,0,0-3.49.75,2.16,2.16,0,0,0-.52,1.49c0,.28,0,.14.14.36a6.16,6.16,0,0,0,2,2.13,2.64,2.64,0,0,0,3-.31A2.69,2.69,0,0,0,241.82,125.91Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,124c-.26-.09-.72,1.68-2.56,2.54s-3.66.17-3.74.41.33.46,1.12.68a4.49,4.49,0,0,0,3.09-.25,4,4,0,0,0,2-2.15C242.2,124.5,242.12,124,242,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.52,106.1c0,.48,1.69.78,3.49,1.6s3.17,1.81,3.54,1.5c.17-.15,0-.64-.44-1.26a6.45,6.45,0,0,0-2.41-1.8,6.38,6.38,0,0,0-2.95-.56C247,105.64,246.52,105.87,246.52,106.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.85,104.22c.3.41,1.61.1,3.17.18s2.84.44,3.17.07c.15-.19,0-.58-.59-1a4.71,4.71,0,0,0-2.53-.79,4.78,4.78,0,0,0-2.58.59C230.92,103.65,230.71,104,230.85,104.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,87.93a2.56,2.56,0,0,0-.11.24l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,149.29c1-3,.41-6.45,1.43-9.48,1.09-3.22,3.83-5.6,5.39-8.62,2.5-4.83,1.73-10.7,2.15-16.16a12.87,12.87,0,0,1-6.78-6.11c-1.8-3.28-2.51-7-3.19-10.72a16.47,16.47,0,0,0,1.27,9.93,4.41,4.41,0,0,1-3.45-2,9.86,9.86,0,0,1-1.46-3.84,27.11,27.11,0,0,1-.08-10,34.93,34.93,0,0,0-1.4,14.22,6.17,6.17,0,0,0-2.61-.45,2.86,2.86,0,0,1-2.34-1,3.15,3.15,0,0,1-.34-1.72,36.21,36.21,0,0,1,2.18-12.19,37.79,37.79,0,0,0-4.16,6.13,13.31,13.31,0,0,0-1.57,7.14,1.07,1.07,0,0,1-1.47-.32,2.54,2.54,0,0,1-.33-1.63A18.57,18.57,0,0,1,234,96.53c-1.64,1.85-2.55,4.21-3.7,6.4s-2.71,4.36-5,5.25a32.27,32.27,0,0,1,2.24-9.06,28.21,28.21,0,0,1,4.21-6.67,22.14,22.14,0,0,1,6.25-5.69c4.16-2.32,5.34-.69,7.33,1l.24.16s0-.1.05-.16l.21-.45a34.18,34.18,0,0,1,17.49,4.58,24.28,24.28,0,0,1,9.52,12.05l.07.25c3.07,10,4.14,21.13-.4,43.67h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,60.56c.06,0,.15.12.15.35a1.17,1.17,0,0,1-.37.81,1.16,1.16,0,0,1-.81.36c-.23,0-.36-.09-.35-.15s.45-.21.8-.58S152.5,60.58,152.65,60.56Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,37.46l.23-.44.24.43a2.13,2.13,0,0,0,.83.8l.44.22-.43.25a2,2,0,0,0-.8.83l-.22.43-.25-.42a2,2,0,0,0-.83-.8l-.43-.23.42-.24A2.13,2.13,0,0,0,274.92,37.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,33.3l.13-.25.14.24a1.27,1.27,0,0,0,.48.47l.26.13-.25.14a1.12,1.12,0,0,0-.46.48l-.14.26-.14-.25a1.21,1.21,0,0,0-.48-.47l-.25-.13.24-.14A1.21,1.21,0,0,0,261.72,33.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,67.13l.13-.25.14.24a1.21,1.21,0,0,0,.48.47l.25.13-.24.14a1.23,1.23,0,0,0-.47.49l-.13.25-.14-.25a1.12,1.12,0,0,0-.48-.46l-.26-.14.25-.14A1.21,1.21,0,0,0,253.84,67.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.25,43.72l.23-.44.24.43a2.09,2.09,0,0,0,.84.8l.43.23-.42.24a2,2,0,0,0-.81.83l-.22.43-.25-.42a2,2,0,0,0-.83-.8l-.43-.23.42-.24A2.13,2.13,0,0,0,329.25,43.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,27.14l.38-.73.41.72a3.47,3.47,0,0,0,1.4,1.34l.73.38-.72.41a3.41,3.41,0,0,0-1.34,1.4l-.38.73-.41-.72a3.41,3.41,0,0,0-1.4-1.34L325.5,29l.72-.41A3.41,3.41,0,0,0,327.56,27.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,23.52l.38-.73.41.72a3.41,3.41,0,0,0,1.4,1.34l.73.38-.72.41a3.41,3.41,0,0,0-1.34,1.4l-.38.73-.41-.72a3.47,3.47,0,0,0-1.4-1.34l-.73-.38.71-.41A3.43,3.43,0,0,0,271.59,23.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.52,91.45l-.19-.8.77.27A3.56,3.56,0,0,0,287,91l.8-.19-.27.77a3.56,3.56,0,0,0-.09,1.94l.2.8-.78-.27A3.56,3.56,0,0,0,285,94l-.8.2.27-.78A3.47,3.47,0,0,0,284.52,91.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,94.62c.58-.57-15.94-4.34-15.94-4.34l-6.14,45.9L266,153.37l-8,1.46-2-5.18-14.82,6.07-12.31-9.87-6.47,5.07-5-1.27c-2.52-3.31-10.91-14.33-12.54-16.77-1.74-2.59-35.42-72-35.69-73.35L153.8,67.74s15.92,40.47,23,60.75,19.5,42.9,19.5,42.9c.67,2.91,12.27,37.53,14.75,47.77,2.75,11.33,3.84,21.4,3.63,20.82l31.74.73L277,230.8s-8.35-20.13-8-21.88,8-30.28,8-30.28,43.22-26.49,45.84-33.75S323.43,95.19,324,94.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,94.62a1.83,1.83,0,0,0-.06.47c0,.32,0,.79,0,1.41,0,1.25,0,3.11.08,5.55.09,4.87.29,12.07.31,21.35,0,4.64,0,9.81-.42,15.46-.11,1.41-.24,2.85-.5,4.31a8.14,8.14,0,0,1-.63,2.17,9.19,9.19,0,0,1-1.34,1.88,57.42,57.42,0,0,1-7.12,6.4c-5.2,4.08-11,8.13-17.22,12.32s-12.9,8.47-20,12.86l.08-.11c-2.11,7.91-4.35,16.33-6.71,25.16-.29,1.11-.57,2.22-.86,3.34-.14.56-.29,1.12-.41,1.67a5.41,5.41,0,0,0,.28,1.62c.66,2.23,1.49,4.44,2.33,6.68,1.69,4.46,3.51,9,5.4,13.56l.09.22-.23.07-30.54,9.92,0,0h0l-31.74-.72.24-.32v0c.16,0-.43-.19-.38,0s-.06.14-.06.11h0v-.17l0-.25,0-.52-.12-1-.28-2.09c-.19-1.4-.41-2.8-.64-4.2q-.7-4.21-1.62-8.46c-1.17-5.66-2.93-11.26-4.67-17s-3.59-11.42-5.45-17.21-3.81-11.61-5.56-17.61l0,.07c-3.66-6.81-7.19-13.9-10.56-21.21s-6.56-14.88-9.29-22.67c-3.66-10.31-7.51-20.43-11.31-30.4s-7.62-19.77-11.39-29.4l-.09-.21.21-.11L169,59.31l.24-.13.13.3c.86,2,1.9,4.18,2.87,6.24l2.95,6.2,5.87,12.21,11.48,23.64c3.77,7.69,7.44,15.22,11.13,22.48.47.91.91,1.81,1.44,2.65l1.81,2.43,3.59,4.79,7,9.39-.12-.07,5,1.27-.19,0,6.48-5.06.13-.11.13.11,12.31,9.87-.21,0L256,149.47l.19-.08.07.19,2,5.18-.21-.12,8-1.45H266l35.92-17.15-.09.11c2.73-20.11,4.83-35.7,6.21-45.89l0-.09.08,0c5.52,1.29,9.55,2.31,12.18,3s3.94,1.21,3.74,1.38c.18-.14-1.14-.61-3.76-1.31s-6.67-1.7-12.2-3l.1-.06c-1.35,10.19-3.41,25.79-6.07,45.91v.08l-.07,0-35.89,17.22h0l-8,1.47-.16,0-.06-.15c-.64-1.65-1.28-3.33-2-5.18l.25.11-14.81,6.08-.11,0-.1-.07L228.77,146H229c-2.09,1.65-4.21,3.31-6.47,5.07l-.08.07-.1,0-5-1.27-.07,0,0-.06-7-9.4q-1.78-2.37-3.59-4.8c-.61-.8-1.21-1.61-1.82-2.42s-1-1.8-1.47-2.7c-3.7-7.27-7.37-14.79-11.15-22.48L180.66,84.35l-5.88-12.21-3-6.2c-1-2.11-2-4.11-2.91-6.36l.37.17L153.92,68l.11-.32q5.67,14.44,11.4,29.41c3.81,10,7.66,20.09,11.32,30.41,2.73,7.77,5.91,15.31,9.27,22.62s6.89,14.39,10.54,21.18l0,0v0c1.73,5.91,3.71,11.76,5.55,17.56s3.69,11.53,5.44,17.22,3.5,11.31,4.67,17q.92,4.24,1.62,8.48c.24,1.4.45,2.81.65,4.21l.28,2.11.11,1.05.05.53,0,.27V240s0,0-.07.15-.56,0-.39,0l0-.06-.16-.33h.4l31.73.74h-.07l30.54-9.9-.13.3c-1.89-4.59-3.7-9.11-5.39-13.58-.84-2.24-1.67-4.46-2.33-6.72a5.23,5.23,0,0,1-.29-1.8c.13-.59.27-1.14.41-1.71.3-1.11.59-2.23.87-3.33l6.75-25.16,0-.07.06,0q10.64-6.57,20-12.83c6.22-4.17,12-8.2,17.23-12.27a56.82,56.82,0,0,0,7.09-6.34,8.42,8.42,0,0,0,1.3-1.82,8,8,0,0,0,.62-2.1c.26-1.44.39-2.88.51-4.28.41-5.63.43-10.8.46-15.44,0-9.28-.15-16.47-.21-21.35,0-2.44,0-4.3,0-5.55A7,7,0,0,1,324,94.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.23,154.79s0,.1-.1.28a5.84,5.84,0,0,1-.4.79,12,12,0,0,1-2,2.62,18.55,18.55,0,0,1-4.13,3,49.07,49.07,0,0,1-5.94,2.66l-.24.1-.08-.25a25.83,25.83,0,0,0-1.92-4.58c-.4-.77-.88-1.5-1.36-2.26l-.38-.55a5.47,5.47,0,0,0-.36-.52c0-.18-.56.2-.93.39a21.67,21.67,0,0,0-4.19,3.29c-.62.6-1.19,1.23-1.76,1.85-.28.31-.55.62-.83.92l-.4.45-.2.23-.09.11,0,0s0,0,0,0,0-.23-.06-.25l-.34.34a74.1,74.1,0,0,1-7.53-8.81c-.84-1.15-1.47-2.08-1.88-2.72a5.78,5.78,0,0,1-.6-1,8.61,8.61,0,0,1,.72.94c.46.62,1.12,1.52,2,2.64a84.12,84.12,0,0,0,7.64,8.64l-.34.34a.3.3,0,0,1,0-.32l0,0,.06-.08.09-.12.2-.23.41-.46.83-.93c.56-.63,1.13-1.27,1.76-1.88a21.85,21.85,0,0,1,4.29-3.38l.61-.34a1.25,1.25,0,0,1,.41-.16.62.62,0,0,1,.52.18,4.1,4.1,0,0,1,.43.6l.39.56c.48.77,1,1.52,1.38,2.31a26,26,0,0,1,1.93,4.68l-.32-.15a54.75,54.75,0,0,0,5.93-2.57,19.16,19.16,0,0,0,4.12-2.87A15.75,15.75,0,0,0,258.23,154.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.89,198.54a10.11,10.11,0,0,1-1.29,1c-.84.6-2.1,1.4-3.69,2.33a73.23,73.23,0,0,1-27.08,9.27c-1.83.24-3.31.38-4.34.42a8.13,8.13,0,0,1-1.6,0,11.31,11.31,0,0,1,1.58-.23c1-.11,2.5-.3,4.31-.58a81.63,81.63,0,0,0,26.95-9.23c1.61-.89,2.89-1.64,3.76-2.18A9.36,9.36,0,0,1,259.89,198.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,207.69a1.89,1.89,0,0,1-.1-.5c-.06-.39-.12-.87-.2-1.45-.16-1.25-.36-3.07-.56-5.33-.4-4.5-.78-10.74-.84-17.65s.23-13.16.57-17.67c.16-2.25.33-4.08.47-5.33.07-.58.13-1.06.17-1.45a1.89,1.89,0,0,1,.1-.5,1.83,1.83,0,0,1,0,.51c0,.39,0,.87-.08,1.45-.08,1.34-.18,3.15-.31,5.35-.24,4.51-.46,10.74-.41,17.64s.38,13.12.69,17.63c.16,2.19.29,4,.39,5.33,0,.58.07,1.06.1,1.45A1.75,1.75,0,0,1,241.2,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,242.92a6.46,6.46,0,0,1-.36-1.29c-.21-.94-.49-2.13-.81-3.56-.68-3-1.62-7.14-2.74-11.7s-2.19-8.67-3-11.64l-.92-3.53a5.58,5.58,0,0,1-.28-1.31,7.19,7.19,0,0,1,.47,1.25c.27.82.64,2,1.08,3.49.88,3,2,7.05,3.14,11.62s2,8.72,2.59,11.75c.29,1.51.51,2.74.65,3.59A6.76,6.76,0,0,1,247.19,242.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,148.91a11.14,11.14,0,0,1,1.27,2.59,30.9,30.9,0,0,1,2.07,13.68,11,11,0,0,1-.45,2.85c-.08,0,0-1.11.09-2.87a39.47,39.47,0,0,0-.41-6.86,40,40,0,0,0-1.64-6.68A26.14,26.14,0,0,1,195,148.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.38,160.9a23.33,23.33,0,0,1-1.55,2.37,47,47,0,0,0-3.36,5.92,45.57,45.57,0,0,0-2.44,6.35,24.49,24.49,0,0,1-.84,2.71,10.88,10.88,0,0,1,.48-2.81,35.74,35.74,0,0,1,5.85-12.38A11.84,11.84,0,0,1,284.38,160.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,70.28a10.4,10.4,0,0,1-2.2,1.34,43.93,43.93,0,0,1-5.69,2.46,43,43,0,0,1-6,1.66,11.08,11.08,0,0,1-2.54.35,15.15,15.15,0,0,1,2.46-.7c1.53-.4,3.62-1,5.89-1.8s4.26-1.65,5.7-2.3A17.07,17.07,0,0,1,173.82,70.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,65.87s.15-.05.41,0a1.71,1.71,0,0,1,.86.72,2,2,0,0,1,.2,1.69,1.94,1.94,0,0,1-3.52,0,1.93,1.93,0,0,1,.23-1.68,1.64,1.64,0,0,1,.88-.7c.26-.08.41,0,.41,0s-.59.16-1,.91a1.62,1.62,0,0,0-.1,1.32,1.39,1.39,0,0,0,1.3.79,1.37,1.37,0,0,0,1.32-.76,1.65,1.65,0,0,0-.07-1.33C167.48,66.05,166.87,66,166.9,65.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.87,62.29c-1.54,1.53-3.12,3-4.62,4.61A6.39,6.39,0,0,0,267.39,72a7,7,0,0,0,2.89,4.81c4.77,4,10.73,7.47,17.13,7.28a17.1,17.1,0,0,0,11.46-5.23c1.25-1.23-.68-3.18-1.94-1.94a14.35,14.35,0,0,1-8.56,4.37,16.69,16.69,0,0,1-8.18-1.42,31.77,31.77,0,0,1-6.88-4.12A9.48,9.48,0,0,1,270.46,73a3.63,3.63,0,0,1,.72-4.15c1.5-1.58,3.08-3.08,4.62-4.61a1.37,1.37,0,0,0-1.93-1.94Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,34.77c1.45-1.44,2.89-2.89,4.35-4.33a3.91,3.91,0,0,1,3.14-1.35c1.61.15,2.53,1.35,3.46,2.51,3.32,4.11,6.27,9.27,6.14,14.71a14.18,14.18,0,0,1-4.46,9.62c-1.23,1.26.7,3.2,1.94,2a17.35,17.35,0,0,0,5.16-10.13A19.54,19.54,0,0,0,323.05,38a35,35,0,0,0-4.84-7.9,9.16,9.16,0,0,0-3.94-3.36,6.31,6.31,0,0,0-5.78.85,51,51,0,0,0-5.42,5.28A1.37,1.37,0,0,0,305,34.77Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,75,318,76.87l0,0-.05.08-.08,0,0,0-1.92,3.07s4.59,5.27,6.25,10.7l4.71-4.7.13-.13,4.72-4.7C326.3,79.57,321,75,321,75Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.06,
    y: 73.98,
    width: 14.38,
    height: 4.59,
    rx: 2.26,
    transform: "translate(38.77 246.32) rotate(-44.93)",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,26.76,284.23,43.09l-.87.86L267.9,59.37c.22.44,30.7,34.22,48.2,15.67l0,0C334.74,57.55,301,27,300.59,26.76Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.59,26.76c2,2,3.94,3.79,5.7,5.72,11.93,13,19.1,27.2,13.38,38.14L315,75.28s5.65-13.08-.51-23.8-14.82-23-14.82-23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M320.87,83.34h14.79a7,7,0,0,1,7,7v.11a0,0,0,0,1,0,0H313.85a0,0,0,0,1,0,0v-.11A7,7,0,0,1,320.87,83.34Z",
    transform: "translate(34.48 257.22) rotate(-44.93)",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.51,
    y: 86.41,
    width: 38.69,
    height: 18.62,
    transform: "translate(30.77 265.85) rotate(-44.93)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.92,
    y: 90.91,
    width: 27.38,
    height: 9.13,
    transform: "translate(30.87 265.61) rotate(-44.93)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,74s-1.61,1.69-3.65,3.72-3.7,3.67-3.73,3.64S317,79.7,319,77.67,322.72,74,322.74,74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.67,70.62s-1.74,1.82-3.94,4-4,4-4,3.93,1.74-1.82,3.94-4S319.64,70.6,319.67,70.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.88,79.14s-2.17,2.25-4.89,5S321,89,321,89s2.16-2.25,4.89-5S330.86,79.12,330.88,79.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,26.76l0,.11-.17.31-.66,1.19-.48.86-.6,1c-.44.72-.91,1.55-1.5,2.42-.29.44-.6.9-.91,1.39s-.67,1-1,1.47l-.55.77c-.09.13-.18.27-.28.4l-.29.39-1.24,1.62a86.19,86.19,0,0,1-6,6.84,88.26,88.26,0,0,1-6.73,6.1l-1.6,1.26-.39.3-.39.29L277,54c-.51.36-1,.73-1.46,1l-1.38.92c-.87.6-1.69,1.08-2.4,1.53l-1,.61-.86.48-1.18.66-.31.17-.11.06.1-.07.31-.18,1.17-.68.85-.49c.31-.18.64-.4,1-.62.71-.45,1.53-.93,2.4-1.54l1.37-.93c.47-.32,1-.69,1.45-1l.76-.56.4-.28.38-.31,1.6-1.26a86.29,86.29,0,0,0,6.71-6.1,87.82,87.82,0,0,0,6-6.81L294,37l.3-.39.28-.4.55-.77c.36-.5.72-1,1-1.46l.92-1.39c.59-.87,1.07-1.69,1.51-2.4.22-.36.43-.69.61-1s.34-.6.49-.85l.68-1.18.18-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.63 50.97 299.36 53.26 305.06 49.01 304.96 56.12 310.76 60.23 303.97 62.33 301.85 69.11 297.76 63.3 290.65 63.39 294.91 57.7 292.63 50.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.59,26.76l.1.09.29.26c.25.23.62.56,1.09,1,.94.88,2.28,2.18,3.86,3.86s3.42,3.73,5.29,6.14a65.81,65.81,0,0,1,5.54,8.23,42.83,42.83,0,0,1,3.91,9.11,27.22,27.22,0,0,1,.87,4.25l.06.5c0,.16,0,.33,0,.49l0,.49c0,.16,0,.32,0,.47,0,.64,0,1.24,0,1.82a17.67,17.67,0,0,1-1.18,5.32c-.23.6-.44,1.06-.59,1.36l-.18.35-.06.11a.67.67,0,0,1,.05-.12c0-.08.09-.2.17-.35.14-.31.34-.76.57-1.36a17.57,17.57,0,0,0,1.13-5.32,17.81,17.81,0,0,0,0-1.8l0-.48,0-.48c0-.16,0-.33,0-.49l-.07-.5a28.26,28.26,0,0,0-.88-4.23,42.56,42.56,0,0,0-3.9-9.08,67.88,67.88,0,0,0-5.52-8.22c-1.87-2.41-3.7-4.47-5.27-6.16S303,29,302,28.15c-.46-.45-.83-.79-1.08-1l-.28-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,77.66l-.09.06-.27.18a7.22,7.22,0,0,1-1.11.54,8.12,8.12,0,0,1-1.89.44,11.81,11.81,0,0,1-2.59,0,19.25,19.25,0,0,1-3.07-.6l-1.67-.48-1.75-.61a46.86,46.86,0,0,1-7.4-3.56,70.62,70.62,0,0,1-6.81-4.6c-2-1.53-3.77-3-5.23-4.22s-2.61-2.26-3.41-3l-.92-.82-.23-.21a.45.45,0,0,1-.08-.08l.08.07.25.2.93.81c.81.7,2,1.71,3.44,2.94s3.22,2.67,5.23,4.19a71.27,71.27,0,0,0,6.81,4.59,49,49,0,0,0,7.38,3.56c.6.2,1.17.42,1.74.61l1.67.49a20.29,20.29,0,0,0,3.05.61,12.38,12.38,0,0,0,2.57,0,8.89,8.89,0,0,0,1.89-.42,7.53,7.53,0,0,0,1.11-.52l.27-.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.74,78.86a1.25,1.25,0,0,0,.18,1.54,3,3,0,0,0,1,.66l.46.21a1.57,1.57,0,0,1-.49-.13,2.56,2.56,0,0,1-1-.66,1.42,1.42,0,0,1-.34-1.18.77.77,0,0,1,.15-.34C312.69,78.89,312.73,78.86,312.74,78.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.68,89.52a1.61,1.61,0,0,1-.24.27,8.06,8.06,0,0,0-.6.75,7.09,7.09,0,0,0-1.22,2.91,7.23,7.23,0,0,0,.16,3.16c.11.39.23.7.31.91l.14.33s0,0-.05-.08-.08-.13-.13-.23a6.78,6.78,0,0,1-.35-.91,6.9,6.9,0,0,1-.2-3.2,6.74,6.74,0,0,1,1.91-3.67,1.38,1.38,0,0,1,.2-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.74,80.5l8.45-8.06a4.51,4.51,0,0,1,.52,4.94,13.1,13.1,0,0,1-3.34,4.05c3.22,1.67,5.6,7,2.73,11.1",
    style: {
      fill: "#b06b5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,90.72s0-.07.07-.19.12-.32.18-.58a7,7,0,0,0,.18-2.23,8.06,8.06,0,0,0-1-3.29,7.59,7.59,0,0,0-3.07-3.09l0,.17a24.16,24.16,0,0,0,2-2A8,8,0,0,0,320,77a5.25,5.25,0,0,0,.29-2.5,3.72,3.72,0,0,0-1-2.16l-.07-.08-.07.07-6,5.82-1.73,1.7-.46.45-.15.17s.07,0,.18-.14l.48-.43,1.77-1.66,6.09-5.76h-.15a3.61,3.61,0,0,1,.94,2,5.25,5.25,0,0,1-.28,2.41,7.92,7.92,0,0,1-1.53,2.45,23.83,23.83,0,0,1-1.94,2l-.1.09.13.07a7.52,7.52,0,0,1,3,3,8.31,8.31,0,0,1,1,3.22,7.46,7.46,0,0,1-.13,2.21C320.09,90.44,320,90.71,320,90.72Z",
    style: {
      fill: "#844e42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,287.64,245.36,240H214.72s-2.59,26.26-3.54,34.18S217.13,370,217.13,370l6.45,82.78h22.84l5.86-91C252.28,349.09,256.73,287.64,256.73,287.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,288.4C297.74,251.85,277,230.8,277,230.8c-.95,0-31.64,9.18-31.64,9.18L256.6,291.6h0l.68,12.56L265,446.92l25.49.27s1.28-23.91,5.18-72.41C298.15,344,301.27,314.94,299.79,288.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,275.53a6.59,6.59,0,0,1-.25-1.21c-.15-.88-.33-2-.55-3.3-.46-2.79-1.12-6.64-2-10.87s-1.72-8-2.38-10.78l-.78-3.26a5.62,5.62,0,0,1-.22-1.21,6.07,6.07,0,0,1,.42,1.15c.24.76.56,1.86.94,3.22.74,2.74,1.68,6.54,2.53,10.78s1.46,8.11,1.82,10.91c.19,1.41.32,2.55.39,3.34A5,5,0,0,1,254,275.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33,252.28a3.41,3.41,0,0,1,.1,1.05,25.76,25.76,0,0,1-.09,2.85,21.25,21.25,0,0,1-2.72,9,14.17,14.17,0,0,1-7.15,6.05,9.92,9.92,0,0,1-2.81.6,3.18,3.18,0,0,1-1,0,17.73,17.73,0,0,0,3.73-.91,14.5,14.5,0,0,0,6.83-6,22.46,22.46,0,0,0,2.8-8.78C226.26,253.77,226.25,252.28,226.33,252.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.38,245c0,.05-.23.11-.59.33a3,3,0,0,0-1.1,1.34,2.9,2.9,0,0,0,0,2.46,2.71,2.71,0,0,0,4.81-.71,2.9,2.9,0,0,0-.66-2.36,3,3,0,0,0-1.44-1c-.41-.11-.66-.1-.66-.15a1.15,1.15,0,0,1,.7-.05,2.94,2.94,0,0,1,1.67.92,3.21,3.21,0,0,1,.86,2.71,2.54,2.54,0,0,1-.88,1.51,3.47,3.47,0,0,1-1.7.76,3.42,3.42,0,0,1-1.85-.24,2.6,2.6,0,0,1-1.27-1.2,3.19,3.19,0,0,1,.05-2.84,2.86,2.86,0,0,1,1.34-1.36A1.21,1.21,0,0,1,240.38,245Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.23,251.14a3.38,3.38,0,0,1-.94.46,9.16,9.16,0,0,1-2.81.58,14.12,14.12,0,0,1-8.88-2.82,26.09,26.09,0,0,1-6.25-7c-.65-1-1.13-1.85-1.46-2.44a3.83,3.83,0,0,1-.45-.94c.07,0,.86,1.22,2.22,3.17a28.13,28.13,0,0,0,6.25,6.77,14.41,14.41,0,0,0,8.56,2.87A15.4,15.4,0,0,0,287.23,251.14Z",
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.71de0d10877344ffb7b76275a5092509.svg";
export { ForwardRef as ReactComponent };